<template>
  <div style="position: relative;">
    <div class="my-background" v-show="my_background_show">
      <div id="layer122" style="display: block; overflow: hidden">
        <div class="layer-div">
          <h3 class="">请插入Ukey校验企业名称</h3>
          <div class="square"></div>
          <p>
            为确保申请企业信息准确无误，请插入甘肃省公共资源交易主体共享平台认证通过的数字证书（Ukey）进行企业信息校验。
          </p>
          <p><a>*</a>特别说明：如果无法正常识别ukey，请更新驱动重试</p>
          <div class="layui-input-inline btn1" style="width: 100%">
            <button @click="_href1" type="button" class="layui-btn">
              没有数字证书，立即办理
            </button>
            <button @click="load_layer" type="button" class="layui-btn">
              已插入Ukey，前往申请保函
            </button>
          </div>
          <div class="AGFooter">
            无法识别数字证书？请先下载
            <a
              href="http://interlinknew.oss-cn-hangzhou.aliyuncs.com/guarantee_letter_2.0/ECCCoderTest/2019-11-25/guarantee_pdf/e3489b0350ab4943b0c7e63f165054fd.exe"
              target="_back"
              >Ukey驱动</a
            >
            安装后重新插入Ukey重试。
          </div>
        </div>
      </div>
    </div>
    <div class="layui-fluid" v-show="from_show">
      <div class="layui-card">
        <div class="layui-card-body" style="height: 665px">
          <div
            class="layui-carousel"
            id="stepForm"
            lay-filter="stepForm"
            style="margin: 0 auto"
          >
            <div class="Box my-step-content" carousel-item>
              <div style="height: 665px" class="step-list">
                <form
                  class="layui-form"
                  style="margin: 0 auto; width: 640px; padding-top: 40px"
                >
                  <div class="Box-1" style="height: 492px; overflow-y: auto">
                    <div class="layui-form-item">
                      <label>投标企业名称 <span> *</span></label>
                      <div class="layui-block">
                        <input
                          disabled
                          name="applyUser"
                          id="CertList"
                          lay-verify="required"
                          v-model="companyname"
                          type="text"
                          placeholder="请填写申请电子保函的招标企业全称"
                          class="layui-input"
                        />
                      </div>
                    </div>
                    <div class="layui-form-item">
                      <div class="layui-inline">
                        <label>项目标段（包）名称<span> *</span></label>
                        <div style="position: relative" class="layui-block">
                          <input
                            style="width: 300px"
                            ref="searchval"
                            v-model="message"
                            @keyup="search"
                            name="blockName"
                            lay-verify="required"
                            type="text"
                            placeholder="请输入您要申请保函的投标项目标段(包)名称"
                            class="layui-input"
                          />
                        </div>
                        <div class="search layui-block" v-show="searchshow">
                          <div
                            style="border: none; width: 100%; overflow: hidden"
                            @click="searchdiv(item.blockName)"
                            class="searchcontent"
                            v-for="(item, index) in searchdata"
                            :key="index"
                          >
                            {{ item.blockName }}
                          </div>
                        </div>
                      </div>
                      <div class="layui-inline right">
                        <label>项目标段（包）编号<span> *</span></label>
                        <div style="width: 300px" class="layui-input-block">
                          <input
                            name="blockCode"
                            v-model="blockCode"
                            lay-verify="required"
                            type="text"
                            placeholder="请输入您要申请保函的投标项目标段(包)编号"
                            class="layui-input"
                          />
                        </div>
                      </div>

                      <div class="clear"></div>
                    </div>

                    <!-- <div class="layui-form-item">
										<div class="layui-inline">
											<label>招标项目名称:<span> *</span></label>
											<div style="width:300px;" class="layui-input-block">
												<input lay-verify="" type="text" placeholder="请填写投标报名项目名称" class="layui-input"  />
											</div>
										</div>
										<div class="layui-inline right">
											<label>招标项目编号:<span> *</span></label>
											<div style="width:300px;" class="layui-input-block">
												<input lay-verify="" type="text" placeholder="请输入您要慎勤保函的投标项目编号" class="layui-input"  />
											</div>
										</div>
										<div class="clear"></div>
									</div> -->

                    <div class="layui-form-item">
                      <div class="layui-inline">
                        <label>招标信息发布平台<span> *</span></label>
                        <div
                          style="width: 300px"
                          class="layui-input-block selectDiv"
                        >
                          <select
                            lay-verify="required"
                            name="tradingPlatformName"
                            lay-filter="aihao"
                            class="select"
                          >
                            <option value="">请选择招标信息发布平台</option>
                            <option value=""></option>
                            <option value="兰州市公共资源交易中心">
                              兰州市公共资源交易中心
                            </option>
                            <option value="金塔县公共资源交易中心">
                              金塔县公共资源交易中心
                            </option>
                            <option value="甘肃省公共资源交易局">
                              甘肃省公共资源交易局
                            </option>
                            <!-- <option value="临夏州公共资源交易中心">临夏州公共资源交易中心</option> -->
                            <option value="武威市公共资源交易中心">
                              武威市公共资源交易中心
                            </option>
                            <option value="金昌市公共资源交易中心">
                              金昌市公共资源交易中心
                            </option>
                            <option value="酒泉市公共资源交易中心">
                              酒泉市公共资源交易中心
                            </option>
                            <option value="张掖市公共资源交易中心">
                              张掖市公共资源交易中心
                            </option>
                            <option value="庆阳市公共资源交易中心">
                              庆阳市公共资源交易中心
                            </option>
                            <option value="天水市公共资源交易中心">
                              天水市公共资源交易中心
                            </option>
                            <option value="白银市公共资源交易中心">
                              白银市公共资源交易中心
                            </option>
                            <option value="陇南市公共资源交易中心">
                              陇南市公共资源交易中心
                            </option>

                            <option value="其他交易平台">其他交易平台</option>
                          </select>
                        </div>
                      </div>
                      <div class="layui-inline right">
                        <label>项目招标人<span> *</span></label>
                        <div style="width: 300px" class="layui-input-block">
                          <input
                            name="projectTenderer"
                            v-model="tradingProjectPerson"
                            lay-verify="required"
                            type="text"
                            placeholder="请输入您要申请保函的投标项目招标人"
                            class="layui-input"
                          />
                        </div>
                      </div>

                      <div class="clear"></div>
                    </div>

                    <div class="layui-form-item">
                      <div class="layui-inline">
                        <label>投标截止时间<span> *</span></label>
                        <div style="width: 300px" class="layui-input-block">
                          <input
                            name="bidOpenTime"
                            lay-verify="required"
                            type="text"
                            placeholder="请输入您要申请保函的投标项目开标时间"
                            class="layui-input"
                            id="date"
                          />
                        </div>
                      </div>
                      <div class="layui-inline right">
                        <label>投标保证金金额（元）<span> *</span></label>
                        <div style="width: 300px" class="layui-input-block">
                          <input
                            v-model="marginAmount"
                            name="marginAmount"
                            lay-verify="number"
                            type="text"
                            placeholder="请输入您要申请保函的投标项目标段(包)的保证金额"
                            class="layui-input"
                          />
                        </div>
                      </div>
                      <div class="layui-inline right" style="display: none">
                        <label>投标保证金金额（元）<span> *</span></label>
                        <div style="width: 300px" class="layui-input-block">
                          <input
                            v-model.number="agetnId"
                            name="agetnId"
                            type="text"
                            placeholder="请输入您要申请保函的投标项目标段(包)的保证金额"
                            class="layui-input"
                          />
                        </div>
                      </div>
                      <div class="layui-inline right" style="display: none">
                        <label>投标保证金金额（元）<span> *</span></label>
                        <div style="width: 300px" class="layui-input-block">
                          <input
                            v-model="guaranteeCompany"
                            name="guaranteeCompany"
                            type="text"
                            placeholder="请输入您要申请保函的投标项目标段(包)的保证金额"
                            class="layui-input"
                          />
                        </div>
                      </div>
                      <div class="clear"></div>
                    </div>

                    <div class="layui-form-item">
                      <div class="layui-inline">
                        <label>投标联系人姓名<span> *</span></label>
                        <div style="width: 300px" class="layui-input-block">
                          <input
                            maxlength="4"
                            name="applyContactName"
                            lay-verify="required|chinese"
                            type="text"
                            placeholder="请输入您要申请保函的报名人姓名"
                            class="layui-input"
                          />
                        </div>
                      </div>
                      <div class="layui-inline right">
                        <label>投标联系人电话<span> *</span></label>
                        <div style="width: 300px" class="layui-input-block">
                          <input
                            name="applyContactMobile"
                            lay-verify="phone"
                            autocomplete="on"
                            type="text"
                            placeholder="请输入您要申请保函报名人联系电话"
                            class="layui-input"
                          />
                        </div>
                      </div>
                      <div class="layui-inline right" style="display: none">
                        <label>投标登记号<span> *</span></label>
                        <div style="width: 300px" class="layui-input-block">
                          <input
                            name="registerNumber"
                            v-model="registerNumber"
                            type="text"
                            placeholder="请输入您要申请保函的投标项目标段(包)编号"
                            class="layui-input"
                          />
                        </div>
                      </div>
                      <div class="clear"></div>
                    </div>
                  </div>

                  <div class="layui-form-item bottom-btn">
                    <div class="layui-input-block">
                      <button
                        type="button"
                        class="layui-btn stepbtn"
                        lay-submit
                        lay-filter="formStep1"
                        @click="money"
                      >
                        下一步
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div style="height: 665px" class="step-list">
                <form
                  class="layui-form"
                  style="
                    overflow: visible;
                    margin: 0 auto;
                    width: 640px;
                    padding-top: 40px;
                  "
                >
                  <div
                    class="Box-1"
                    style="
                      overflow-x: visible;
                      padding-left: 149px;
                      height: 492px;
                      overflow-y: auto;
                      width: 648px;
                    "
                  >
                    <ul class="layui-timeline">
                      <li class="layui-timeline-item">
                        <i class="layui-icon layui-timeline-axis"></i>
                        <div class="layui-timeline-content layui-text">
                          <div class="timeline-title-div">
                            <h3 class="layui-timeline-title">申请人：</h3>
                          </div>
                          <p>
                            {{ companyname }}
                          </p>
                        </div>
                      </li>
                      <li class="layui-timeline-item" v-show="blockName_show">
                        <i class="layui-icon layui-timeline-axis"></i>
                        <div class="layui-timeline-content layui-text">
                          <div class="timeline-title-div">
                            <h3 class="layui-timeline-title">项目名称：</h3>
                          </div>
                          <p>{{ blockName }}</p>
                        </div>
                      </li>
                      <li
                        class="layui-timeline-item"
                        v-show="registerNumber_show"
                      >
                        <i class="layui-icon layui-timeline-axis"></i>
                        <div class="layui-timeline-content layui-text">
                          <div class="timeline-title-div">
                            <h3 class="layui-timeline-title">投标登记号：</h3>
                          </div>
                          <p>{{ registerNumber }}</p>
                        </div>
                      </li>
                      <li class="layui-timeline-item">
                        <i class="layui-icon layui-timeline-axis"></i>
                        <div class="layui-timeline-content layui-text">
                          <div class="timeline-title-div">
                            <h3 class="layui-timeline-title">项目招标人：</h3>
                          </div>
                          <p>
                            {{ projectTenderer }}
                          </p>
                        </div>
                      </li>
                      <li class="layui-timeline-item">
                        <i class="layui-icon layui-timeline-axis"></i>
                        <div class="layui-timeline-content layui-text">
                          <div class="timeline-title-div">
                            <h3 class="layui-timeline-title">
                              保证金金额(担保金额)：
                            </h3>
                          </div>
                          <p>{{ marginAmount }}元</p>
                        </div>
                      </li>
                      <li class="layui-timeline-item">
                        <i class="layui-icon layui-timeline-axis"></i>
                        <div class="layui-timeline-content layui-text">
                          <div class="timeline-title-div">
                            <h3 class="layui-timeline-title">金融机构：</h3>
                          </div>
                          <div>
                            <div class="guarantee-div">
                              <div
                                v-for="(item, index) in categories"
                                :key="index"
                                @click="changeBorder(item, index)"
                                class="check_box"
                              >
                                <div
                                  :class="[
                                    categoriesIndex == index
                                      ? 'changed'
                                      : 'unchanged',
                                  ]"
                                ></div>
                                <img :src="item.img" />
                                <div class="rate"><span></span></div>
                                <div
                                  :data-index="index"
                                  @click.stop="lookdetails($event, item)"
                                  class="look-details cursor"
                                  v-if="item.text !== '甘肃金控'"
                                >
                                  查看详情
                                </div>
                                <input
                                  :data-index="index"
                                  type="radio"
                                  class="yz"
                                  name="sex"
                                  :value="index"
                                  :title="index"
                                  lay-verify="checkboxmustbe"
                                />
                                <!-- <input class="fuxuan" lay-verify="checkboxmustbe" lay-filter="yz"  type="checkbox" name="a" :title="index" lay-skin="primary"> -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="layui-timeline-item">
                        <i class="layui-icon layui-timeline-axis"></i>
                        <div class="layui-timeline-content layui-text">
                          <div class="timeline-title-div">
                            <h3 class="layui-timeline-title">保函费用：</h3>
                          </div>
                          <p v-show="bhmoneyShow">
                            <span
                              class="count"
                              v-if="guaranteeAmount === ''"
                              style="margin-right: 20px"
                              >*</span
                            >
                            <span
                              class="count original"
                              v-else
                              style="margin-right: 20px"
                              >{{ guaranteeAmount }}</span
                            >
                            <span
                              class="count"
                              style="
                                text-decoration: line-through;
                                color: #999;
                                font-size: 14px;
                              "
                              >{{ guaranteePay }}</span
                            >

                            元
                          </p>
                          <p v-show="lanzhouMoney">以实际计算金额为准</p>
                        </div>
                      </li>
                      <!-- 黄河财险 -->
                      <template v-if="nowSelectCateid == 4">
                        <li class="layui-timeline-item" v-show="nongYeShow">
                          <i class="layui-icon layui-timeline-axis"></i>
                          <div class="layui-timeline-content layui-text">
                            <div class="timeline-title-div">
                              <h3 class="layui-timeline-title">
                                <span>*</span>发票申请：
                              </h3>
                            </div>
                            <div class="layui-input-block" style="width: 300px">发票申请请在保函开具成功之后联系黄河财险, 联系电话: {{ phone }}</div>
                          </div>
                        </li>
                      </template>
                      <template v-else>
                        <li class="layui-timeline-item" v-show="lanzhouCounp">
                          <i class="layui-icon layui-timeline-axis"></i>
                          <div class="layui-timeline-content layui-text">
                            <div class="timeline-title-div">
                              <h3 class="layui-timeline-title">优惠券：</h3>
                            </div>
                            <div style="width: 300px" class="layui-input-block">
                              <!-- <div style="position: relative;display:flex" v-show="counpInput">
                                <input style="width:200px" name="coupon" maxlength="10"   autocomplete="on" type="text" placeholder="请输入优惠券券码" class="layui-input" v-model="coupon"/>
                                <button type="button" @click="couponClick" style="width:120px;margin-left:20px;cursor: pointer;width: 77px;margin-left: 20px;margin-top: 10px; border: none;font-size: 13px;background: #fff;border: 1px solid #19AECF;color: #19AECF;">确认使用</button>
                                <span style="position: absolute;top: 37px;left: 0px;font-size: 10px;color: red;" v-show="couponShow">{{couponMsg}}</span>
                              </div> -->
                              <p
                                style="
                                  opacity: 1 !important;
                                  height: 20px;
                                  position: absolute;
                                  top: 7px;
                                  left: 0px;
                                "
                                v-show="counpRadio"
                              >
                                <input
                                  lay-filter="invoice-type"
                                  type="radio"
                                  name="couponRadio"
                                  value="4"
                                  title="不使用优惠券"
                                  checked
                                />
                                <input
                                  lay-filter="invoice-type"
                                  type="radio"
                                  name="couponRadio"
                                  value="3"
                                  title="使用优惠券"
                                />
                              </p>
                            </div>
                          </div>
                        </li>
                        <li class="layui-timeline-item" v-show="counpInput">
                          <i class="layui-icon layui-timeline-axis"></i>
                          <div class="layui-timeline-content layui-text">
                            <div class="timeline-title-div">
                              <h3 class="layui-timeline-title"></h3>
                            </div>
                            <div style="width: 300px" class="layui-input-block">
                              <div
                                style="
                                  position: relative;
                                  display: flex;
                                  margin-top: 9px;
                                "
                              >
                                <input
                                  style="width: 200px"
                                  name="coupon"
                                  maxlength="10"
                                  autocomplete="on"
                                  type="text"
                                  placeholder="请输入优惠券券码"
                                  class="layui-input"
                                  v-model="coupon"
                                />
                                <button
                                  type="button"
                                  @click="couponClick"
                                  style="
                                    width: 120px;
                                    margin-left: 20px;
                                    cursor: pointer;
                                    width: 77px;
                                    margin-left: 20px;
                                    margin-top: 10px;
                                    border: none;
                                    font-size: 13px;
                                    background: #fff;
                                    border: 1px solid #19aecf;
                                    color: #19aecf;
                                  "
                                >
                                  确认使用
                                </button>
                                <span
                                  style="
                                    position: absolute;
                                    top: 37px;
                                    left: 0px;
                                    font-size: 10px;
                                    color: red;
                                  "
                                  v-show="couponShow"
                                  >{{ couponMsg }}</span
                                >
                              </div>
                              <!-- <p style="opacity:1 !important;height:20px;position: absolute;top: 7px;left: 0px;" v-show="counpRadio">
                              <input lay-filter="invoice-type"  type="radio" name="couponRadio" value="3" title="使用优惠券" >
                              <input lay-filter="invoice-type" type="radio" name="couponRadio" value="4" title="不使用优惠券" checked>
                            </p> -->
                            </div>
                          </div>
                        </li>
                        <li class="layui-timeline-item" v-show="lanzhouRadio">
                          <i class="layui-icon layui-timeline-axis"></i>
                          <div class="layui-timeline-content layui-text">
                            <div class="timeline-title-div">
                              <h3 class="layui-timeline-title">开票选择：</h3>
                            </div>
                            <p class="p_radio">
                              <input
                                lay-filter="invoice-type"
                                id="one_radio"
                                type="radio"
                                name="invoiceStatus"
                                value="0"
                                title="不开票"
                                checked
                              />
                              <input
                                lay-filter="invoice-type"
                                type="radio"
                                name="invoiceStatus"
                                value="1"
                                title="增值税普通发票"
                              />
                              <input
                                lay-filter="invoice-type"
                                id="zy_radio"
                                type="radio"
                                name="invoiceStatus"
                                value="2"
                                title="增值税专用发票"
                              />
                            </p>
                          </div>
                        </li>
                        <li
                          class="layui-timeline-item"
                          v-if="guarantorId == 0 && open"
                        >
                          <i class="layui-icon layui-timeline-axis"></i>
                          <div class="layui-timeline-content layui-text">
                            <div class="timeline-title-div">
                              <h3 class="layui-timeline-title">
                                <span> *</span>开票信息：
                              </h3>
                            </div>
                            <div class="billingInformation">
                              <div class="billingInput">
                                <h3 class="layui-timeline-title">企业名称：</h3>
                                <p>
                                  {{ companyname }}
                                </p>
                              </div>
                              <div class="billingInput">
                                <h3 class="layui-timeline-title">
                                  营业执照号码：
                                </h3>
                                <p>
                                  {{ uniformCreditCode }}
                                </p>
                              </div>
                              <div class="billingInput">
                                <h3 class="layui-timeline-title">
                                  <span class="requiredRed"> *</span
                                  >{{ billingAddress }}：
                                </h3>
                                <input
                                  :lay-verify="
                                    billingAddress == '电子邮箱'
                                      ? 'mailVerify'
                                      : 'required'
                                  "
                                  name="mailAddress"
                                  type="text"
                                  :placeholder="
                                    billingAddress == '电子邮箱'
                                      ? '用于向您发送电子发票邮箱地址'
                                      : '用于向您邮寄纸质发票'
                                  "
                                  class="layui-input"
                                />
                              </div>
                              <div class="billingInput">
                                <h3 class="layui-timeline-title">
                                  <span
                                    v-if="requiredInvoice"
                                    class="requiredRed"
                                  >
                                    *</span
                                  >注册地址：
                                </h3>
                                <input
                                  :lay-verify="
                                    requiredInvoice == true ? 'required' : ''
                                  "
                                  id="legalUnitAddress"
                                  name="legalUnitAddress"
                                  type="text"
                                  placeholder="请输入企业注册地址"
                                  class="layui-input"
                                />
                              </div>
                              <div class="billingInput">
                                <h3 class="layui-timeline-title">
                                  <span
                                    v-if="requiredInvoice"
                                    class="requiredRed"
                                  >
                                    *</span
                                  >联系电话：
                                </h3>
                                <input
                                  :lay-verify="
                                    requiredInvoice == true ? 'phone' : ''
                                  "
                                  name="contactMobile"
                                  type="text"
                                  placeholder="请输入您的联系方式"
                                  class="layui-input"
                                />
                              </div>
                              <div class="billingInput">
                                <h3 class="layui-timeline-title">
                                  <span
                                    v-if="requiredInvoice"
                                    class="requiredRed"
                                  >
                                    *</span
                                  >开户银行：
                                </h3>
                                <input
                                  :lay-verify="
                                    requiredInvoice == true ? 'required' : ''
                                  "
                                  name="bankName"
                                  type="text"
                                  placeholder="请输入企业开户银行"
                                  class="layui-input"
                                />
                              </div>
                              <div class="billingInput">
                                <h3 class="layui-timeline-title">
                                  <span
                                    v-if="requiredInvoice"
                                    class="requiredRed"
                                  >
                                    *</span
                                  >银行账号：
                                </h3>
                                <input
                                  :lay-verify="
                                    requiredInvoice == true ? 'required' : ''
                                  "
                                  name="bankAccount"
                                  type="text"
                                  placeholder="请输入企业银行账号"
                                  class="layui-input"
                                />
                              </div>
                              <p>
                                1、开票信息将与您的企业信息一致<br />
                                2、担保机构发票开具时间为固定时间<br />
                                3、发票有疑问请联系担保机构：（甘肃融资担保）15009426422<br />
                                4、出函有疑问请联系担保机构：（甘肃融资担保）15343617521
                              </p>
                            </div>
                          </div>
                        </li>
                        <li
                          class="layui-timeline-item"
                          v-if="guarantorId != 0 && open"
                        >
                          <i class="layui-icon layui-timeline-axis"></i>
                          <div class="layui-timeline-content layui-text">
                            <div class="timeline-title-div">
                              <h3 class="layui-timeline-title">
                                <span>*</span>{{ address }}地址：
                              </h3>
                            </div>
                            <div class="layui-input-block" style="width: 300px">
                              <input
                                :lay-verify="nongyeCorpKind ? 'required' : ''"
                                name="mailAddress"
                                type="text"
                                :placeholder="'请输入您的发票' + address + '地址'"
                                class="layui-input"
                              />
                            </div>
                          </div>
                        </li>
                        <li
                          class="layui-timeline-item"
                          v-if="guarantorId != 0 && open"
                        >
                          <i class="layui-icon layui-timeline-axis"></i>
                          <div class="layui-timeline-content layui-text">
                            <div class="timeline-title-div">
                              <h3 class="layui-timeline-title">
                                <span>*</span>联系方式：
                              </h3>
                            </div>
                            <div class="layui-input-block">
                              <input
                                :lay-verify="nongyeCorpKind ? 'phone' : ''"
                                name="contactMobile"
                                style="width: 300px"
                                type="text"
                                placeholder="请输入您的联系电话"
                                class="layui-input"
                              />
                              <p v-if="nowSelectCateid == -1">
                                1、开票信息将与您的企业信息一致<br />
                                2、担保机构发票开具时间为固定时间，有疑问请电话联系担保机构：********
                              </p>
                              <p v-else-if="Name == '中国人保'">
                                1、开票信息将与您的企业信息一致<br />
                                2、发票有疑问请联系担保机构：13993648503
                              </p>
                              <p v-else>
                                1、开票信息将与您的企业信息一致
                                <template v-if="phone">
                                  <br/>
                                  2、担保机构发票开具时间为固定时间，有疑问请电话联系{{
                                    Name
                                  }}担保机构：{{ phone }}
                                </template>
                                <br />
                              </p>
                            </div>
                          </div>
                        </li>
                      </template>

                      <!-- 新增 -->
                      <li class="layui-timeline-item" v-show="blockNameTwoShow">
                        <i class="layui-icon layui-timeline-axis"></i>
                        <div class="layui-timeline-content layui-text">
                          <div class="timeline-title-div">
                            <h3 class="layui-timeline-title">
                              <span>*</span>项目标段（包）名称：
                            </h3>
                          </div>
                          <div class="layui-input-block" style="width: 300px">
                            <div style="position: relative" class="layui-block">
                              <input
                                style="width: 300px"
                                ref="searchvalTwo"
                                v-model="messageTwo"
                                @keyup="searchTwo"
                                :lay-verify="blockNameTwoShow ? 'required' : ''"
                                name="blockNameTwo"
                                type="text"
                                placeholder="请输入您要申请保函的投标项目标段(包)名称"
                                class="layui-input blocNameRequired"
                              />
                            </div>
                            <div
                              class="search layui-block"
                              v-show="searchshow"
                              style="top: 37px"
                            >
                              <div
                                style="
                                  border: none;
                                  width: 100%;
                                  overflow: hidden;
                                "
                                @click="searchdivTwo(item.blockName)"
                                class="searchcontent"
                                v-for="(item, index) in searchdata"
                                :key="index"
                              >
                                {{ item.blockName }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <!-- 兰州银行, 选择 -->
                      <li class="layui-timeline-item" v-show="lanzhouCorpKind">
                        <i class="layui-icon layui-timeline-axis"></i>
                        <div class="layui-timeline-content layui-text">
                          <div class="timeline-title-div">
                            <h3 class="layui-timeline-title">
                              <span>*</span>企业性质：
                            </h3>
                          </div>
                          <div class="layui-input-block" style="width: 300px">
                            <div class="layui-input-block">
                              <select
                                name="corpKind"
                                :lay-verify="lanzhouCorpKind ? 'required' : ''"
                              >
                                <option value=""></option>
                                <option value="1">国有企业</option>
                                <option value="2">股份有限</option>
                                <option value="3">有限责任</option>
                                <option value="4">民营</option>
                                <option value="5">中外合资</option>
                                <option value="6">外商独资</option>
                                <option value="7">集体单位</option>
                                <option value="8">事业单位</option>
                                <option value="190">其他</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="layui-timeline-item" v-show="nongYeShow">
                        <i class="layui-icon layui-timeline-axis"></i>
                        <div class="layui-timeline-content layui-text">
                          <div class="timeline-title-div">
                            <h3 class="layui-timeline-title">
                              <span>*</span>企业从业人数：
                            </h3>
                          </div>
                          <div class="layui-input-block" style="width: 300px">
                            <input
                              :lay-verify="nongyeCorpKind ? 'numberTwo' : ''"
                              name="employeesNumber"
                              type="number"
                              placeholder="请输入企业从业人数"
                              class="layui-input"
                            />
                          </div>
                        </div>
                      </li>
                      <li class="layui-timeline-item" v-show="nongYeShow">
                        <i class="layui-icon layui-timeline-axis"></i>
                        <div class="layui-timeline-content layui-text">
                          <div class="timeline-title-div">
                            <h3 class="layui-timeline-title">
                              <span>*</span>企业营业收入(万元)：
                            </h3>
                          </div>
                          <div class="layui-input-block" style="width: 300px">
                            <input
                              name="turnover"
                              :lay-verify="nongyeCorpKind ? 'required' : ''"
                              type="number"
                              placeholder="请输入企业营业收入"
                              class="layui-input"
                            />
                          </div>
                        </div>
                      </li>
                      <li class="layui-timeline-item" v-show="nongYeShow">
                        <i class="layui-icon layui-timeline-axis"></i>
                        <div class="layui-timeline-content layui-text">
                          <div class="timeline-title-div">
                            <h3 class="layui-timeline-title">
                              <span>*</span>企业资产总额(万元)：
                            </h3>
                          </div>
                          <div class="layui-input-block" style="width: 300px">
                            <input
                              name="totalAssets"
                              :lay-verify="nongyeCorpKind ? 'required' : ''"
                              type="number"
                              placeholder="请输入企业资产总额"
                              class="layui-input"
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                    <div v-if="sunshinePurchase && Name == '甘肃'">
                      1、发票有疑问请联系担保机构：（甘肃融资担保）15009426422<br />
                      2、出函有疑问请联系担保机构：（甘肃融资担保）15343617521
                    </div>
                  </div>
                  <div class="layui-form-item bottom-btn2">
                    <div class="layui-input-block">
                      <button
                        type="button"
                        class="stepbtn layui-btn layui-btn-primary onepre"
                        v-show="accreditPre"
                      >
                        上一步
                      </button>
                      <button
                        class="layui-btn stepbtn"
                        lay-submit
                        lay-filter="formStep2"
                      >
                        {{ field1.guarantor == 17 || field1.guarantor == 5 || field1.guarantor == 4 ? "提交" : "下一步" }}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div style="" class="step-list">
                <!-- <iframe src="https://mozilla.github.io/pdf.js/web/viewer.html" width="100%" height="99%"></iframe> -->
                <form
                  class="layui-form"
                  style="overflow: visible; margin: 0 auto"
                >
                  <div class="main3 overflow">
                    <div class="main3-left">
                      <h2 class="h2-title">请使用您的UKey为以下文件签章：</h2>
                      <p class="small-title"></p>
                      <ul class="ul1">
                        <li class="offline-signature">
                          <h2>
                            <img src="@/assets/a.png" />
                            《出具投标保函申请书》
                            <template v-if="!offlineSignature">
                              <a
                                :href="null"
                                target="blank1"
                                class="preview1 preview cursor"
                                style="display: none"
                                ><span>下载预览</span></a
                              >
                              <button
                                type="button"
                                data-cateid="0"
                                @click="signOnline"
                                class="signatrue signtrueOne"
                                style="height: 30px; line-height: 30px"
                              >
                                <span class="cursor">在线签章</span>
                              </button>
                            </template>
                            <template v-else>
                              <div class="offline-signature-btn">
                                <button
                                  type="button"
                                  @click="getOfflineSignatureFile(0)"
                                  class="signatrue signtrueOne"
                                >
                                  <span class="cursor">下载申请书</span>
                                </button>
                                <el-upload
                                  ref="application"
                                  :action="this.upUrl + '/file/uploadSignature'"
                                  :disabled="!offlineDownFileApplication"
                                  :before-upload="
                                    (file) =>
                                      offlineSignatureBefUp(
                                        file,
                                        'applicationText'
                                      )
                                  "
                                  :on-success="
                                    (res) =>
                                      offlineSignatureAftersuccess(
                                        res,
                                        'application',
                                        'applicationUrl',
                                        'applicationText'
                                      )
                                  "
                                  :limit="1"
                                  :on-error="
                                    (err) =>
                                      offlineSignatureError(
                                        err,
                                        'application',
                                        'applicationText'
                                      )
                                  "
                                  :show-file-list="false"
                                >
                                  <button
                                    type="button"
                                    @click="repplay('application')"
                                    class="signatrue signtrueOne"
                                    :class="
                                      offlineDownFileApplication
                                        ? ''
                                        : 'signatrue-disabled'
                                    "
                                  >
                                    <span class="cursor">{{
                                      applicationText
                                    }}</span>
                                  </button>
                                </el-upload>
                              </div>
                            </template>
                            <div class="offline-signature-switch">
                              <a
                                v-if="applicationUrl && offlineSignature"
                                :href="applicationUrl"
                                target="_blank"
                                class="preview cursor"
                                ><span>下载预览</span></a
                              >
                              <p @click="offlineSignature = !offlineSignature">
                                {{
                                  offlineSignature
                                    ? "使用在线签章"
                                    : "没有UKey, 使用离线签章"
                                }}
                              </p>
                            </div>
                          </h2>
                          <span class="look-instance"
                            ><a
                              :href="require('../../assets/img/shenqing.png')"
                              target="_blank"
                              >查看示例</a
                            ></span
                          >
                        </li>
                        <li
                          class="offline-signature"
                          v-if="field1.guarantor != 2"
                        >
                          <h2>
                            <img src="@/assets/a.png" />
                            《企业征信授权书》
                            <template v-if="!offlineSignature">
                              <a
                                :href="null"
                                target="blank2"
                                class="preview2 preview cursor"
                                style="display: none"
                                ><span>下载预览</span></a
                              >
                              <button
                                type="button"
                                data-cateid="1"
                                @click="signOnline"
                                class="signatrue signtrueTwo"
                                style="height: 30px; line-height: 30px"
                              >
                                <span class="cursor">在线签章</span>
                              </button>
                            </template>
                            <template v-else>
                              <div class="offline-signature-btn">
                                <button
                                  type="button"
                                  @click="getOfflineSignatureFile(1)"
                                  class="signatrue signtrueOne"
                                >
                                  <span class="cursor">下载授权书</span>
                                </button>
                                <el-upload
                                  ref="powerOfAttorney"
                                  :action="this.upUrl + '/file/uploadSignature'"
                                  :disabled="!offlineDownFilePowerOfAttorney"
                                  :before-upload="
                                    (file) =>
                                      offlineSignatureBefUp(
                                        file,
                                        'powerOfAttorneText'
                                      )
                                  "
                                  :on-success="
                                    (res) =>
                                      offlineSignatureAftersuccess(
                                        res,
                                        'powerOfAttorney',
                                        'powerOfAttorneyUrl',
                                        'powerOfAttorneText'
                                      )
                                  "
                                  :limit="1"
                                  :on-error="
                                    (err) =>
                                      offlineSignatureError(
                                        err,
                                        'powerOfAttorney',
                                        'powerOfAttorneText'
                                      )
                                  "
                                  :show-file-list="false"
                                >
                                  <button
                                    type="button"
                                    @click="repplay('powerOfAttorney')"
                                    class="signatrue signtrueOne"
                                    :class="
                                      offlineDownFilePowerOfAttorney
                                        ? ''
                                        : 'signatrue-disabled'
                                    "
                                  >
                                    <span class="cursor">{{
                                      powerOfAttorneText
                                    }}</span>
                                  </button>
                                </el-upload>
                              </div>
                            </template>
                            <div class="offline-signature-switch">
                              <a
                                v-if="powerOfAttorneyUrl && offlineSignature"
                                :href="powerOfAttorneyUrl"
                                target="_blank"
                                class="preview cursor"
                                ><span>下载预览</span></a
                              >
                              <p @click="offlineSignature = !offlineSignature">
                                {{
                                  offlineSignature
                                    ? "使用在线签章"
                                    : "没有UKey, 使用离线签章"
                                }}
                              </p>
                            </div>
                            <input
                              lay-verify="signverify"
                              type="text"
                              placeholder="请输入企业营业收入"
                              class="layui-hide layui-input"
                            />
                          </h2>
                          <!-- <span class="look-instance"><a href="././assets/img/shouquan.png" target="_blank">查看示例</a></span> -->
                          <span class="look-instance"
                            ><a
                              :href="require('../../assets/img/shouquan.png')"
                              target="_blank"
                              >查看示例</a
                            ></span
                          >
                        </li>
                        <li v-if="field1.guarantor != 2">
                          <h2>
                            <img src="@/assets/a.png" />
                            请上传《企业资质证书》
                            <a
                              href="#"
                              target="blank3"
                              class="previe3 preview cursor"
                              ><span>下载预览</span></a
                            >
                            <el-upload
                              ref="my-upload"
                              style="width: 94px; height: 30px"
                              class="upload-demo signatrue"
                              :action="this.upUrl + '/file/upload'"
                              :on-success="aftersuccess"
                              :limit="1"
                            >
                              <el-button
                                @click="repplay('my-upload', 'view3')"
                                style="
                                  line-height: 0;
                                  background: #19aecf;
                                  width: 94px;
                                  height: 30px;
                                  border-radius: none;
                                  border: none;
                                "
                                size=""
                                type="primary"
                                >{{ view3 }}</el-button
                              >
                            </el-upload>
                          </h2>
                          <!-- <span class="look-instance"><a href="././assets/img/zizhi.png" target="_blank">查看示例</a></span> -->
                          <span class="look-instance"
                            ><a
                              :href="require('../../assets/img/zizhi.png')"
                              target="_blank"
                              >查看示例</a
                            ></span
                          >
                        </li>
                      </ul>
                    </div>
                    <hr />
                    <div class="main3-right">
                      <h2>常见问题</h2>
                      <ul>
                        <li>
                          <h3>
                            <img
                              src="@/assets/b.png"
                            />为什么必须使用Ukey进行在线签章？
                          </h3>
                          <p>
                            使用电子签章可以有效避免外部人员冒充公司进行电子保函申请。
                          </p>
                        </li>
                        <li>
                          <h3>
                            <img
                              src="@/assets/b.png"
                            />可以使用哪些UkeyY对文件进行在线签章？
                          </h3>
                          <p>
                            当前只支持使用陕西CA对文件进行在线签章。
                          </p>
                        </li>
                        <li>
                          <h3>
                            <img src="@/assets/b.png" />没有企业资质证书怎么办？
                          </h3>
                          <p>
                            根据担保机构要求，建筑行业企业必须上传企业资质证书，非建筑商业选择性上传。
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="layui-form-item bottom-btn3">
                    <div class="layui-input-block">
                      <button
                        type="button"
                        class="stepbtn layui-btn layui-btn-primary pre fourPre"
                      >
                        上一步
                      </button>
                      <div class="layui-btn stepbtn" @click="upFileSubmit('0')">
                        提交
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <span>未安装签章控件，请下载签章控件后重试</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="clickUk">
          下载签章控件
          <a
            id="download_UK"
            style="display: none"
            href="http://interlinknew.oss-cn-hangzhou.aliyuncs.com/guarantee_letter_2.0/ECCCoderTest/2019-11-25/guarantee_pdf/e3489b0350ab4943b0c7e63f165054fd.exe"
            >hehe
          </a>
        </el-button>
      </span>
    </el-dialog>

    <!-- <div id="layer110" style="display: none;">
			I LOVE YOU !
		</div> -->
    <!-- <div id="needknow" style="display: none;overflow: hidden;">
			<applyneedknow :konwlayer2="konwlayer2"></applyneedknow>
		</div> -->
    <div class="feedbackdiv" v-show="lanzhouMsg">
      <div
        class="feedback_content"
        style="margin-top: -220px; margin-left: -240px"
      >
        <div class="feedback_top">业务办理所需资料：</div>
        <div class="feedback_center">
          <!-- <div id="u9_div" class=""></div> -->
          <div id="feedback_text">
            <p>
              <span>1.&nbsp;在线申请办理，在线支付，无需线下提交文件资料。</span>
            </p>
          </div>
        </div>
        <div class="feedback_top">开票办理流程：</div>
        <div class="feedback_center">
          <!-- <div id="u9_div" class=""></div> -->
          <div id="feedback_text">
            <p>
              <span>1.&nbsp;成功开具保函；</span>
            </p>
            <p>
              <span>2.&nbsp;拨打兰州银行客服电话；</span>
            </p>
            <p>
              <span>3.&nbsp;告知客服企业开票信息、订单信息、收件邮箱。</span>
            </p>
            <p>
              <span><br /></span>
            </p>
            <p>
              <span>客服电话：0791-86806097、19100155931</span>
            </p>
            <p>
              <span>值班时间：周一至周五  09:00-18:00</span>
            </p>
            <p>
              <span><br /></span>
            </p>
          </div>
        </div>
        <div class="feedback_button">
          <div @click="otherDb">选择其他担保</div>
          <div @click="sureCheck" class="sureCheck">确认并选择</div>
        </div>
      </div>
    </div>
    <el-dialog
      title="农业银行投标保函为线下办理流程"
      :visible.sync="nongyeMsgShow"
      width="970px"
      custom-class="nongyeDialog"
      center
    >
      <div class="nongyeMsg">
        <div class="n-title">线下办理流程：</div>
        <div class="msgContent">
          <img src="@/assets/nongyeFlow.png" alt="" class="nongyeFlowImg" />
        </div>
        <div class="n-title">保函开立所需材料：</div>
        <div class="msgContent">
          <div class="materials">
            <p>1.开立保函申请书。</p>
            <p>2.营业执照、开户许可证、机构信用代码证、法定代表人身份证明</p>
            <p>
              3.申请人从事特殊行业或应取得环保许可的，应提供有权部门出具的特种行业经营许可证、资质证明、环保许可等批准材料。
            </p>

            <div v-show="materialShow">
              <p>
                4.公司章程、董事会（或股东会）同意申请信用授权书等证明材料。
              </p>
              <p>
                5.近三年财务年报与近期财务报表，成立不足三年的客户，提交自成立以来的年度报表及近期报表。（注：仅办理低风险业务的，提供近1年和最近1期）
              </p>
              <p>
                6.保函申请人与受益人签订的基础交易合同或协议等证明基础交易背景和保函用途的材料。
              </p>
              <p>
                7.工程建设项目的可行性研究报告或项目招标书等可用于项目评估的材料。
              </p>
              <p>8.政府或监管部门批准文件等可用于证明项目合法性的材料。</p>
            </div>
            <p v-show="!materialShow">...</p>
            <p>9.征信查询资料等</p>
            <div class="readMore" @click="materialFold">
              <div class="border"></div>
              <span>{{ materialFoldText }}</span>
              <img src="@/assets/unfold.png" alt="" class="readMoreImg" />
              <div class="border"></div>
            </div>
          </div>
          <div class="downApplication">
            <div class="radio"></div>
            <span>开立国内保函申请书：</span>
            <a href="https://wrjy-test.oss-cn-beijing.aliyuncs.com/%E4%BF%9D%E5%87%BD%E6%96%87%E4%BB%B6/%E9%99%84%E4%BB%B63%EF%BC%9A%E5%BC%80%E7%AB%8B%E5%9B%BD%E5%86%85%E4%BF%9D%E5%87%BD%E7%94%B3%E8%AF%B7%E4%B9%A6ABC%282013%291017-1.doc">下载</a>
          </div>
        </div>
        <div class="n-title">联系电话及办理地点：</div>
        <div class="msgContent">
          <el-table
            :data="nongyeTableData"
            :header-cell-style="{
              textAlign: 'center',
              background: '#F2F2F2',
              fontSize: '13px',
              color: '#333333',
            }"
            :cell-style="{
              textAlign: 'center',
              fontSize: '10px',
              color: '#333333',
            }"
          >
            <el-table-column prop="networkName" label="网点名称">
            </el-table-column>
            <el-table-column prop="name" label="负责人"> </el-table-column>
            <el-table-column prop="phone" label="联系电话"> </el-table-column>
            <el-table-column prop="specialPlane" label="电话">
            </el-table-column>
            <el-table-column prop="address" label="电话地址"> </el-table-column>
          </el-table>
          <div class="readMore readMore2" @click="nongyeFoldTable">
            <div class="border"></div>
            <span>{{ nongyeFoldTableText }}</span>
            <img src="@/assets/unfold.png" alt="" class="readMoreImg" />
            <div class="border"></div>
          </div>
        </div>
        <div class="n-title">保函开立时间：在调查资料完备、保证金可正常到位的情况下，保函开立时间为<span>5</span>个工作日。</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="nongyeOthereGuarantorCheck" class="nongyeMsgCancel"
          >选择其他担保机构</el-button
        >
        <el-button
          type="primary"
          @click="nongyeGuarantorCheck"
          class="nongyeMsgSure"
          >确认并选择</el-button
        >
      </span>
    </el-dialog>

    <!-- 登陆状态为-16, -17 -->
    <dialog-accredit-to-2 ref="dialogAccreditTo2"/>

    <aboutgansu
      id="layer-gansu"
      style="display: none; height: 100%"
    ></aboutgansu>
    <abouthanhua
      id="layer-hanhua"
      style="display: none; height: 100%"
    ></abouthanhua>
    <aboutlanzhou
      id="layer-lanzhou"
      style="display: none; height: 100%"
    ></aboutlanzhou>
    <aboutnongye
      id="layer-nongye"
      style="display: none; height: 100%"
    ></aboutnongye>
    <aboutpicc id="layer-picc" style="display: none; height: 100%"></aboutpicc>
  </div>
</template>

<script>
import $ from "jquery";
import "@/assets/css/viewer.min.css";
import viewerjs from "@/assets/js/viewer.min.js";
// import online from "@/assets/js/sign_online.js";
import Lay from "@/assets/js/layui_method.js";
import aboutgansu from "@/components/apply-baohan/about_gansu.vue";
import abouthanhua from "@/components/apply-baohan/about_hanhua.vue";
import aboutlanzhou from "@/components/apply-baohan/about_lanzhou.vue";
import aboutnongye from "@/components/apply-baohan/about_nongye.vue";
import aboutpicc from "@/components/apply-baohan/about_picc.vue";
import applyneedknow from "@/components/apply-baohan/applyneedknow.vue";
import dialogAccreditTo2 from "@/components/dialog/dialogAccreditTo2.vue";
import defaultSettings from "../../modules/config/defaultSettings";
import {
  topEsa,
  certificate,
  TCACErr,
  CertStore,
  getThisUser,
} from "../../assets/js/topEsa.min";
import { searchname, dzbhMoney } from "../../apis/apis";
import { guaranteeAgencys } from "@/config/guaranteeAgencys";

import { mapGetters } from "vuex";
var companyInfo = { id: "", name: "" };
export default {
  components: {
    aboutgansu,
    abouthanhua,
    aboutlanzhou,
    aboutpicc,
    applyneedknow,
    aboutnongye,
    dialogAccreditTo2
  },
  data() {
    return {
      nongyeCorpKind:true,
      nongyeCategoriesIndex:-1,
      nongyeTableData: [],
      nongyeTableAllData: [
        {
          networkName: "嘉峪关公司业务部",
          name: "鲁文杰",
          phone: "18993781632",
          specialPlane: "0937-6329418",
          address: "新华中路616号",
        },
        {
          networkName: "嘉峪关分行营业部",
          name: "孙国雄",
          phone: "18993783316",
          specialPlane: "0937-6329470",
          address: "新华中路616号",
        },
        {
          networkName: "嘉峪关分行酒钢支行",
          name: "柴振华",
          phone: "15009477557",
          specialPlane: "0937-6329471",
          address: "酒钢诚信大厦内",
        },
        {
          networkName: "嘉峪关分行火车站支行",
          name: "车颖志",
          phone: "18009477762",
          specialPlane: "0937-6329473",
          address: "火车站车务段楼下",
        },
        {
          networkName: "嘉峪关分行大唐路支行",
          name: "刘金娥",
          phone: "13993792175",
          specialPlane: "0937-6329474",
          address: "大唐美食街北门",
        },
        {
          networkName: "嘉峪关分行新中支行",
          name: "刘梦莎",
          phone: "18693776685",
          specialPlane: "0937-6329472",
          address: "陇达鞋城楼下",
        },
        {
          networkName: "嘉峪关分行文化宫支行",
          name: "李建丽",
          phone: "13993780289",
          specialPlane: "0937-6329475",
          address: "新华超市对面",
        },
        {
          networkName: "嘉峪关分行嘉北支行",
          name: "郑晓婷",
          phone: "15293788640",
          specialPlane: "0937-6329476",
          address: "酒钢三中路口处",
        },
        {
          networkName: "嘉峪关分行迎西支行",
          name: "樊翔",
          phone: "18093773985",
          specialPlane: "0937-6329477",
          address: "西部公司昌盛店楼下",
        },
      ],
      materialShow: false,
      nongyeTableShow: false,
      materialFoldText: "展开更多",
      nongyeFoldTableText: "展开更多",
      nongyeMsgShow: false,
      layuiForm: null,
      requiredInvoice: false,
      billingAddress: "电子邮箱",
      uniformCreditCode: "",
      // 天台保函 项目标段（包）名称 后面如果要求保函里展示项目名称再对接
      blockNameTwoShow: false,
      nongYeShow: true,
      lanzhouCorpKind: false,
      messageTwo: "",
      lanzhouMsg: false,
      lanzhouRadio: true,
      lanzhouCounp: true,
      lanzhouMoney: false,
      bhmoneyShow: true,
      counpInput: false,
      counpRadio: true,
      centerDialogVisible: false,
      guaranteePay: "",
      guaranteeSale: "",
      newGuaranteeFee: "",
      changeNum: "",
      guarantorId: "",
      couponShow: false,
      couponMsg: "优惠券券码不能小于10位并且请选择担保方",
      coupon: "",
      ddemo: "",
      registerNumber: "",
      registerNumber_show: false,
      blockName_show: true,
      projectTenderer: "",
      blockName: "",
      accreditPre: true,
      from_show: false,
      my_background_show: true,
      guaranteeCompany: "",
      agetnId: "",
      applyContactMobile: "",
      applyContactName: "",
      marginAmount: "",
      bidOpenTime: "",
      blockCode: "",
      applyUser: "",
      tradingProjectPerson: "",
      tradingPlatformName: "",
      // 模糊查询
      message: "",
      searchdata: [],
      searchshow: false,
      num: "number",
      open: false,
      nowSelectCateid: -1, // 当前选中categories的cateid
      categories: [],
      categoriesIndex: -1, // 当前选中categories下标
      changed: false,
      layer122: "",
      field1: "",
      guaranteeAmount: "",
      companyname: "",
      address: "邮寄",
      fif: true,
      view3: "点击上传",
      href1: null,
      // var applyurl2 = localStorage.getItem('applyurl');
      href2: null,
      href3: null,
      Name: "",
      phone: "",
      index: "",
      needknow: true,
      konwlayer: "",
      applyCompanyUser: "",
      upUrl: "",
      // fileList: [{name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}, {name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}]
      offlineSignature: false, // 是否使用离线签章
      applicationText: "上传已签章申请书", // 申请书上传按钮文本
      powerOfAttorneText: "上传已签章授权书", // 授权书上传按钮文本
      applicationUrl: "", // 申请书上传成功后地址
      powerOfAttorneyUrl: "", // 授权书上传成功后地址
      upload_file: "",
      // 判断文件是否下载, 只有先下载以后才允许上传
      offlineDownFileApplication: false,
      offlineDownFilePowerOfAttorney: false,
      // 限制文件上传类型
      uploadType: ["jpg", "png", "pdf"],
      accreditStatus: "",
      accreditNum:"",
    };
  },
  computed: {
    href1_1() {
      return this.href1;
    },
    href2_2() {
      return this.href2;
    },
    href3_3() {
      return this.href3;
    },
    konwlayer2() {
      return this.konwlayer;
    },
    ...mapGetters({
      sunshinePurchase: "getSunshinePurchasee",
      designatedGuaranteeAgencys: "getDesignatedGuaranteeAgencys",
    }),
  },
  created() {
    this.upUrl = defaultSettings.serviceUrl;
    if (this.changeNum == "1" && this.guaranteeAmount != "") {
      this.couponShow = false;
    }
    sessionStorage.removeItem("applyurl");
    sessionStorage.removeItem("allowpowerurl");
    // 阅读协议  更改uk样式
    // if(sessionStorage.getItem("from_show") == "1"){
    // 	this.from_show = true;
    // 	this.my_background_show = false;
    // }

    // 授权登录
    this.accreditStatus = sessionStorage.getItem("accredit")
    if (["1", "2"].includes(this.accreditStatus)) {
      this.blockNameTwoShow = false;
      this.accreditPre = false;
      this.my_background_show = false;
      this.from_show = true;
      this.blockName_show = false;
      this.registerNumber_show = true;
      this.companyname = sessionStorage.getItem("sq_applyUser");
      this.uniformCreditCode = sessionStorage.getItem("uniformCreditCode");
      this.registerNumber = sessionStorage.getItem("sq_registerNumber");
      this.projectTenderer = sessionStorage.getItem("sq_projectTenderer");
      this.marginAmount = sessionStorage.getItem("sq_marginAmount");

      this.field1 = {
        guarantor: "",
        marginAmount: this.marginAmount,
        projectTenderer: this.projectTenderer,
        tradingPlatformName: sessionStorage.getItem("getCompanyname"),
        applyUser: this.companyname,
        registerNumber: this.registerNumber,
        // projectTenderer  guaranteeFee    marginAmount  registerNumber  tradingPlatformName
      };
    }
  },
  mounted() {
    // 根据不同地区地区, 项目类型设定可选担保机构
    this.isCategories();
    // 如果已经申请成功, 那么this.accreditStatus为2
    this.accreditTo2()
    const isAccredit = ["1", "2"].includes(this.accreditStatus)
    this.accreditNum = isAccredit ? '1' : "";
    var that = this;

    // $(".check_box").eq(0).hide();
    // UK认证
    if (topEsa.TopESAConfig()) {
      initCertList();
    }
    function initCertList() {
      try {
        var certs = CertStore.listAllCerts().byKeyUsage(128); // 过滤签名证书
        var certs_validity = CertStore.listAllCerts()
          .byKeyUsage(128)
          .byValidity(); // 过滤有效期内的签名证书
        var certs_size = certs.size();
        var certs_validity_size = certs_validity.size();
        if (certs_size < 1) {
          that.companyName = "未查询到证书信息，请使用key来获取证书信息";
        } else {
          var companyNum = 0;
          for (var i = 0; i < certs_size; i++) {
            var cert = certs.get(i);
            var sn = cert.serialNumber();
            var cn = getCNFromSubject(cert);

            for (let j = 0; j < certs_validity_size; j++) {
              var cert_validity = certs_validity.get(j);
              var sn_validity = cert_validity.serialNumber();
              if (sn == sn_validity) {
                var newName = cn.replace(/-/g, "");
                var reg = /^\w+$/;
                if (reg.test(newName)) {
                  continue;
                }
                companyInfo.id = cert.serialNumber();
                console.log("wruyerg");
                console.log(companyInfo);
                // companyInfo.name = cn;
                companyNum++;
              }
            }
          }
          if (companyNum == 0) {
            console.log("未查询到证书信息，请使用key来获取证书信息");
          } else if (companyNum > 1) {
            that.companyName = "检测到多个证书信息，请不要同时使用多个key";
          }
        }
      } catch (e) {
        if (e instanceof TCACErr) {
          console.log(e.toStr());
        } else {
          console.log("过滤证书异常！");
        }
      }
    }

    // 从Certificate对象中获取CN
    function getCNFromSubject(cert) {
      try {
        var t = cert
          .subject()
          .match(/(S(?!N)|L|O(?!U)|OU|SN|CN|E)=([^=]+)(?=, |$)/g);
        for (var i = 0; i < t.length; i++) {
          if (t[i].indexOf("CN=") === 0) return t[i].substr(3, t[i].length);
        }
        return null;
      } catch (e) {
        if (e instanceof TCACErr) {
          console.log(e.toStr());
        } else {
          console.log("获取CN异常!");
        }
      }
    }

    // 隐藏已上传文件列表
    $(".el-upload-list").hide();
    // 获取当前日期后三个工作日的日期
    function getAfterFormatDate(days) {
      // 如果需要计算当前的日期 传 0 即可 (此例是考虑时分秒的情况)
      let dd = new Date();
      dd.setDate(dd.getDate() + days); // 获取days天后的日期
      let y = dd.getFullYear();
      let m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      let d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      let hour = dd.getHours() < 10 ? "0" + dd.getHours() : dd.getHours();
      let min = dd.getMinutes() < 10 ? "0" + dd.getMinutes() : dd.getMinutes();
      let second =
        dd.getSeconds() < 10 ? "0" + dd.getSeconds() : dd.getSeconds();
      return y + "-" + m + "-" + d;
    }
    var df = getAfterFormatDate(3);
    // var layer122;
    layui.use(
      ["jquery", "element", "step", "form", "laydate", "layer"],
      function () {
        var $ = layui.jquery;
        var form = layui.form;
        var step = layui.step;
        var element = layui.element;
        var layer = layui.layer;
        that.layuiForm = form;
        var laydate = layui.laydate;
        // 执行一个laydate实例
        laydate.render({
          elem: "#date", // 指定元素
          btns: ["clear", "confirm"],
          min: df,
        });

        // 表单验证
        form.verify({
          chinese: function (value) {
            if (value != value.replace(/[^\u4E00-\u9FA5]/g, "")) {
              return "请输入正确的联系人姓名";
            }
          },
          checkboxmustbe: function (value) {
            console.log(value)
            if (!$(".yz").is(":checked")) {
              return "金融机构必选";
            }
          },
          mailVerify: function (value) {
            var reg =
              /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
            if (!reg.test(value)) {
              return "请输入正确的邮箱";
            }
          },
          // signverify: function(value) {
          // 	if (!$(".preview2").is(":visible")||!$(".preview1").is(":visible") ) {
          // 		return "请完善签章";
          // 	}
          // },
          numberTwo: function (value) {
            var reg = /^\d+$|^\d+[.]?\d+$/;
            if (!reg.test(value)) {
              return "请输入数字";
            }
          },
          // chinese:[/[^\u4E00-\u9FA5]/g,'hanzi'],
          content: function (value) {
            layedit.sync(editIndex);
          },
        });
        $(".preview").hide();
        // 首页两个弹层
        if (that.fif) {
          that.layer122 = layer.open({
            type: 1,
            title: false,
            closeBtn: 0,
            scrollbar: false,
            area: "520px",
            skin: "layui-layer-nobg", // 没有背景色
            // content: $('#layer122')
          });
          $(".layui-layer").css("box-shadow", "none");
        }
        // 判断是否弹出协议框
        var agreed = sessionStorage.getItem("agreed");
        if (!agreed == true) {
          that.konwlayer = layer.open({
            type: 1,
            title: false,
            area: ["972px", "611px"],
            closeBtn: 0,
            scrollbar: false,
            skin: "layui-layer-nobg", // 没有背景色
            content: $("#needknow"),
          });
          $(".layui-layer").css("box-shadow", "none");
        }

        var com = companyInfo.name;
        console.log("sfkjshlkj");
        console.log(com);
        var timer = setInterval(() => {
          if (
            com == "null" ||
            com == null ||
            com == undefined ||
            com == "undefined" ||
            com == ""
          ) {
          } else {
            that.$store.state.companyname = companyInfo.name;
            var conmpany = com.split(";");
            that.$store.state.companyname = conmpany[0];
            that.companyname = that.$store.state.companyname;
          }
        }, 500);

        laydate.render();
        step.render({
          elem: "#stepForm",
          filter: "stepForm",
          width: "100%", // 设置容器宽度
          stepWidth: "100%",
          height: "500px",
          stepItems: [
            {
              title: "填写项目报名信息",
            },
            {
              title: "选择保函申请机构",
            },
            {
              title: "上传申请材料",
            },
          ],
        });
        $(".layui-timeline-axis").hover(
          function () {
            $(this).css("color", "#5FB878");
          },
          function () {
            $(this).css("color", "#5FB878");
          }
        );
        // 创建弹层
        // var layer122;
        // var com = sessionStorage.getItem('companyname');

        /* var timer = setInterval(
				 ()=>{
				if(com=='null'||com==null){
					 var isShow = $('#layer122').is(":visible");
					 if(isShow){
					 }else{
						 that.jj();
					 }
				 }else{
					 that.$store.state.companyname = sessionStorage.getItem('companyname');
					  var conmpany = com.split(';');
					  that.$store.state.companyname = conmpany[0];
					  that.companyname = that.$store.state.companyname;
					  layer.close(that.layer122);
					  $('#layer122').hide();
					   // that.jj();
				 }
				 }
				 ,500); */

        // 授权登陆
        if (isAccredit) {
          step.goStep(2);
        }
        $(".signtrueOne").click(function () {
          // console.log(111);

          $(".signtrueOne").attr("disabled", true);
          setTimeout(function () {
            $(".signtrueOne").removeAttr("disabled");
          }, 5000);
        });
        $(".signtrueTwo").click(function () {
          // console.log(222);

          $(".signtrueTwo").attr("disabled", true);
          setTimeout(function () {
            $(".signtrueTwo").removeAttr("disabled");
          }, 5000);
        });
        $(".sureCheck").click(function () {
          $("input:radio[name=invoiceStatus][value='0']").prop(
            "checked",
            "true"
          );
          $("input:radio[name=sex][value='1']").prop("checked", "true");
          // $("input:radio[name=couponRadio][value='4']").prop("checked","true");
          form.render();
          that.open = false;
          // console.log("兰州优惠券"+ that.coupon);
          if (that.guaranteePay != "") {
            // that.counpInput = true;
          }
        });
        form.on("radio(invoice-type)", function (data) {
          that.requiredInvoice = false;
          // 被点击的radio的value值
          if (data.value == "1" || data.value == "2") {
            that.open = true;
            that.billingAddress = data.value == "1" ? "电子邮箱" : "邮寄地址";
            that.requiredInvoice = data.value == "2";
          } else if (data.value == "3") {
            that.counpInput = true;
            that.counpRadio = true;
          } else if (data.value == "4") {
            that.counpInput = false;
            that.counpRadio = true;
            that.coupon = "";
            that.couponShow = false;
            var params = {
              tradingPlatformName: "",
              marginAmount: "",
              guarantor: "",
              couponCode: "",
            };
            params.tradingPlatformName = that.field1.tradingPlatformName;
            params.marginAmount = that.field1.marginAmount;
            params.guarantor = that.guarantorId;
            params.couponCode = "";
            console.log(params.guarantor);

            if (that.nowSelectCateid != 6) {
              this.$http
                .get("/ApplyInfo/dzbhMoney", {
                  params,
                  headers: { tokenId: that.$store.state.tokenId },
                })
                .then((res) => {
                  var money = "";
                  if (res.data.data.msg == "") {
                    that.field1.guaranteeAmount = res.data.data.guaranteePay;
                    that.guaranteePay = "";
                    that.newGuaranteeFee = res.data.data.guaranteeFee;
                    that.guaranteeAmount = res.data.data.guaranteePay;
                    that.guaranteeSale = res.data.data.guaranteeSale;
                    money = res.data.data.guaranteePay;
                    that.couponShow = false;
                  } else {
                    that.couponMsg = res.data.data.msg;
                    that.couponShow = true;
                  }
                });
            }
          } else {
            that.open = false;
          }
        });

        form.render();
        form.on("submit(formStep1)", function (data) {
          that.field1 = data.field;
          // console.log(that.field1);

          that.blockName = data.field.blockName;
          that.projectTenderer = data.field.projectTenderer;
          $(".my-step-content")
            .find(".step-list")
            .eq(1)
            .show()
            .siblings()
            .hide();
          step.goStep(2);
          return false;
        });

        // 第二步点击下一步按钮事件
        form.on("submit(formStep2)", function (data) {
          debugger;
          console.log(that.field1);
          that.field1 = Object.assign(that.field1, data.field);
          that.field1.guaranteeFee = that.guaranteeAmount;
          if (that.field1.guarantor == 17 || that.field1.guarantor == 5 || that.field1.guarantor == 4) {
            // 如果为甘肃金控, 黄河财险或则中国农业银行, 直接提交. 不显示上传文件界面
            that.upFileSubmit("0");
          } else {
            $(".my-step-content")
              .find(".step-list")
              .eq(2)
              .show()
              .siblings()
              .hide();
            step.goStep(3);
          }
          return false;
        });
        $(".onepre").click(function () {
          that.nowSelectCateid = 6;
          console.log("$('.onepre').click==>", that.nowSelectCateid);
          that.guaranteeAmount = "";
          that.guaranteePay = "";
          that.guarantorId = "";
          $("input:radio[name=couponRadio][value='4']").prop("checked", "true");
          $("input:radio[name=invoiceStatus][value='0']").prop(
            "checked",
            "true"
          );
          $("input:radio[name=sex][value='0']").removeAttr("checked");
          $("input:radio[name=sex][value='1']").removeAttr("checked");
          $("input:radio[name=sex][value='2']").removeAttr("checked");
          // $("input:radio[name=invoiceStatus][value='0']").prop("checked","true")

          $("#zy_radio").next().show();
          that.open = false;
          form.render();
          that.counpInput = false;
          that.counpRadio = true;
          that.coupon = "";
          that.couponShow = false;
          step.goStep(1);

          // step.pre('#stepForm');
        });
        // $('.pre').click(function() {
        // 	step.pre('#stepForm');
        // });
        $(".fourPre").click(function () {
          $(".preview1").hide();
          $(".preview1").next().find("span").text("在线签章");
          $(".preview2").hide();
          $(".preview2").next().find("span").text("在线签章");
          step.goStep(2);
        });

        // $('.next').click(function() {
        // 	step.next('#stepForm');
        // });
        form.render();

        
        // 公航旅默认显示黄河财险
        that.changeBorder(that.categories[0], 0);
      }
    );
    // 签章
  },
  beforeDestroy() {
    $(".layui-layer-shade").hide();
  },
  methods: {
    accreditTo2(){
      if(this.accreditStatus === "2"){
        // 删除界面下一步按钮
        this.$nextTick(() => {
          $(".layui-form-item.bottom-btn2").remove();
        });
        const msg = {
          "-16": "您已提交保函申请，请耐心等待担保机构审核",
          "-17": "您已成功申请电子保函，请不要重复申请"
        }
        const accreditStatus = sessionStorage.getItem("accreditStatus")
        const accreditPhone = sessionStorage.getItem("accreditPhone")
        const payUrl = sessionStorage.getItem("payUrl")
        this.$refs.dialogAccreditTo2.init({flag: true, phone:accreditPhone, msg:msg[accreditStatus], payUrl})
      }
    },
    // 农业银行选择其他担保机构
    nongyeOthereGuarantorCheck(){
      this.nongyeMsgShow = false;
    },
    // 农业银行担保方确认选择
    nongyeGuarantorCheck(){
      this.nongYeShow = false;
      this.nongyeCorpKind = false,
      this.nowSelectCateid = 5;
      this.field1.guarantor = 5;
      this.guarantorId = 5;
      this.open = false;
      this.categoriesIndex = this.nongyeCategoriesIndex;
      this.bhmoneyShow = true;
      this.lanzhouMoney = false;
      $("input:radio[name=invoiceStatus][value='0']").prop("checked", "true");
      $("input:radio[name=sex][value='0']").prop("checked", "true");
      this.layuiForm.render();
      this.getGuaranteeAmount();
      this.nongyeMsgShow = false;
        //  this.$router.push("/nognyeSuccess");
    },
    switchNongyeFold(){
      if (this.nongyeTableShow == false) {
        this.nongyeTableData = this.nongyeTableAllData.slice(0, 3);
      } else {
        this.nongyeTableData = this.nongyeTableAllData;
      }
    },
    nongyeFoldTable() {
      this.nongyeTableShow = !this.nongyeTableShow;
      this.nongyeFoldTableText =
        this.nongyeTableShow == true ? "点击收起" : "展开更多";
        this.switchNongyeFold();
    },
    // 保函开立所需材料展开收起
    materialFold() {
      this.materialShow = !this.materialShow;
      this.materialFoldText =
        this.materialShow == true ? "点击收起" : "展开更多";
    },
    // 下载签章控件
    clickUk() {
      this.centerDialogVisible = false;
      var download_UK = document.getElementById("download_UK");
      download_UK.click();
    },
    // 优惠券
    couponClick() {
      var that = this;
      var money = "";
      if (this.coupon.length == 10 && this.changeNum == "1") {
        this.couponShow = false;
        var params = {
          tradingPlatformName: "",
          marginAmount: "",
          guarantor: "",
          couponCode: "",
        };
        params.tradingPlatformName = that.field1.tradingPlatformName;
        params.marginAmount = that.field1.marginAmount;
        params.guarantor = that.guarantorId;
        params.couponCode = this.coupon;
        // console.log(this.coupon.length);
        this.couponShow = false;
        this.$http
          .get("/ApplyInfo/dzbhMoney", {
            params,
            headers: { tokenId: that.$store.state.tokenId },
          })
          .then((res) => {
            if (res.data.data.msg == "") {
              that.field1.guaranteeAmount = res.data.data.guaranteePay;
              this.guaranteePay = res.data.data.guaranteeFee;
              this.newGuaranteeFee = res.data.data.guaranteeFee;
              this.guaranteeAmount = res.data.data.guaranteePay;
              this.guaranteeSale = res.data.data.guaranteeSale;
              money = res.data.data.guaranteePay;
              this.couponShow = false;
            } else {
              this.couponMsg = res.data.data.msg;
              this.couponShow = true;
            }
          });
      } else {
        this.couponShow = true;
      }
    },
    money() {
      console.log(typeof this.marginAmount.type);
    },
    searchdivTwo(blockName) {
      this.messageTwo = blockName;
      if (this.messageTwo == blockName) {
        this.searchshow = false;
        var params = { name: "" };
        params.name = this.messageTwo;

        this.$http
          .get("/ApplyInfo/getAgentProjectByName", {
            params,
            headers: { tokenId: this.$store.state.tokenId },
          })
          .then((res) => {
            var data = JSON.parse(res.data.data.data).data;
            // 	for(let i = 0;i<data.length;i++){
            // 	this.marginAmount = data[i].marginAmount;
            // 	this.blockCode = data[i].blockCode;
            // 	this.tradingProjectPerson = data[i].tradingProjectPerson;
            // 	this.agetnId = data[i].agetnId;
            // }
          });
      }
    },
    searchdiv(blockName) {
      this.message = blockName;
      // this.messageTwo = blockName
      if (this.message == blockName) {
        this.searchshow = false;
        searchname(this.message).then((res) => {
          var data = JSON.parse(res.data.data.data).data;
          for (let i = 0; i < data.length; i++) {
            this.marginAmount = data[i].marginAmount;
            this.blockCode = data[i].blockCode;
            this.tradingProjectPerson = data[i].tradingProjectPerson;
            this.agetnId = data[i].agetnId;
          }
        });
      }
    },
    searchTwo() {
      let searchText = this.$refs.searchvalTwo.value;
      if (searchText == "" || searchText.length < 4) {
        this.searchshow = false;
      } else {
        var params = { name: "" };
        params.name = this.messageTwo;
        this.$http
          .get("/ApplyInfo/getAgentProjectByName", {
            params,
            headers: { tokenId: this.$store.state.tokenId },
          })
          .then((res) => {
            // debugger
            this.searchdata = JSON.parse(res.data.data.data).data;
            // console.log(this.searchdata);
            if (this.searchdata) {
              this.searchshow = true;
            }
          });
      }
    },
    // 模糊查询
    search() {
      let searchText = this.$refs.searchval.value;
      if (searchText == "" || searchText.length < 4) {
        this.searchshow = false;
      } else {
        searchname(searchText).then((res) => {
          this.searchdata = JSON.parse(res.data.data.data).data;
          // console.log(this.searchdata);

          if (this.searchdata) {
            this.searchshow = true;
          }
        });
      }
    },
    lookdetails(e, item) {
      console.log(e, item);
      if (e && e.preventDefault) {
        e.preventDefault(); // 非IE浏览器
      } else {
        window.event.returnValue = false;
      }
      // 黄河财险跳转对方官网
      if(item.cateid == 4){
        window.open('https://www.ypic.cn/html1/folder/1407/1001-1.htm')
        return
      }
      let eleId = `#layer-${item.label}`;
      let title = `关于${item.text}`;
      Lay.WeAdminEdit(title, eleId, null, 1, 1);
      //   if (e.currentTarget.dataset.index == 0) {
      //   } else if (e.currentTarget.dataset.index == 1) {
      //     Lay.WeAdminEdit("关于瀚华担保", "#layer112", null, 1, 1);
      //   } else if (e.currentTarget.dataset.index == 2) {
      //     Lay.WeAdminEdit("关于兰州银行", "#layer113", null, 1, 1);
      //   }
    },
    repplay(target, thisView) {
      // 未下载文件, 不得上传.
      if (target == "powerOfAttorney" && !this.offlineDownFilePowerOfAttorney) {
        this.$message.error("请先下载授权书文件, 签章之后再提交上传");
        return;
      } else if (target == "application" && !this.offlineDownFileApplication) {
        this.$message.error("请先下载申请书文件, 签章之后再提交上传");
        return;
      }
      this.$refs[target].clearFiles();
    },
    aftersuccess(file) {
      var that = this;
      this.upload_file = file.body.url_0;
      $(".previe3").attr("href", file.body.url_0);
      $(".previe3").show();
      console.log(file.body.url_0);
      that.view3 = "重新上传";
    },
    load_layer() {
      var that = this;

      var params;
      that.$store.state.companyname = companyInfo.name;
      that.companyname = companyInfo.name;
      var companycode = companyInfo.id;
      var resualt2;

      this.$http
        .get("/ApplyInfo/getCompanyInfo?certId=" + companycode, {
          headers: {
            "content-type": "application/json",
            tokenId: that.$store.state.tokenId,
          },
          xhrFields: {
            withCredentials: true,
          },
        })
        .then((res) => {
          resualt2 = res;
          console.log(res);
          layui.use(["layer"], function () {
            var layer = layui.layer;
            console.log(resualt2.data.status);
            if (resualt2.data.status == 1) {
              sessionStorage.removeItem("companyname");
              $(".layui-layer-shade").hide();
              layer.close(that.layer122);
              that.my_background_show = false;
              that.from_show = true;
              sessionStorage.setItem("from_show", "1");
              $("#layer122").hide();
              if (resualt2.data) {
                var BiddingBodyName = resualt2.data.data[0].BiddingBodyName;
                that.companyname = BiddingBodyName;
                companyInfo.name = BiddingBodyName;
              }
            } else {
              that.companyname = BiddingBodyName;
              layer.msg("未查询到企业信息，请插入Ukey或重装驱动后重试");
            }
          });
          if (res.data.status == 1) {
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    _href1() {
      window.location.href = "http://www.jian-yi.com";
    },
    // 选择其他担保
    otherDb() {
      this.lanzhouMsg = false;
      // that.nowSelectCateid = ""
      // this.nowSelectCateid = 3;
    },

    // 选择兰州银行提示框
    sureCheck() {
      $("input:radio[name=couponRadio][value='4']").prop("checked", "true");
      $("input:radio[name=sex][value='0']").prop("checked", "true");
      this.lanzhouMsg = false;
      this.nowSelectCateid = 2;
      this.bhmoneyShow = false;
      this.lanzhouMoney = true;
      this.guaranteeCompany = "lanzhou";
      this.lanzhouCounp = false;
      this.lanzhouRadio = true;
      this.guaranteeAmount = "";
      this.open = false;
      this.guaranteeAmount = 0;
      this.guaranteePay = "";
      this.coupon = "";
      // this.counpRadio = true;
      this.counpInput = false;
      this.lanzhouCorpKind = true;
      this.field1.guarantor = 2;
      this.Name = "";
      this.phone = "";
    },

    // 担保机构选项卡, 点击事件
    changeBorder(item, index) {
      $("#one_radio").next().show();
      $("#zy_radio").next().show();
      this.nongyeCorpKind = true;
      this.lanzhouCorpKind = false;
      this.open = false;
      this.nongYeShow = true;
      this.blockNameTwoShow = false;
      // TODO 选择担保机构, 添加黄河财险
      if (item.cateid == 0) {
        this.nowSelectCateid = 0;
        this.address = "邮寄";
        this.Name = "甘肃";
        this.phone = "15009426422";
        this.guaranteeCompany = "gsdbjt";
        this.changeNum = "1";
        this.bhmoneyShow = true;
        this.lanzhouMoney = false;
        this.lanzhouCounp = true;
        this.lanzhouRadio = true;
        // $("input:radio[name=invoiceStatus][value='1']").prop("checked", "true");
        // $("input:radio[name=sex][value='0']").prop("checked", "true");
        $("input:radio[name=invoiceStatus][value='1']").prop("checked", "true");
        $("input:radio[name=sex][value='0']").prop("checked", "true");
        this.layuiForm.render();
        $("#one_radio").next().hide();
        this.open = true;
        this.field1.guarantor = 0;
      } else if (item.cateid == 1) {
        this.address = "邮箱";
        this.Name = "瀚华";
        this.phone = "0931-8418302 18152149071";
        this.guaranteeCompany = "hhjr";
        this.changeNum = "1";
        this.bhmoneyShow = true;
        this.lanzhouMoney = false;
        this.lanzhouCounp = true;
        this.lanzhouRadio = true;
        $("input:radio[name=invoiceStatus][value='0']").prop("checked", "true");
        this.layuiForm.render();
        $("#zy_radio").next().hide();
        this.nowSelectCateid = 1;
        $("input[data-index^='1']").attr("checked", "checked");
        this.field1.guarantor = 1;
        // console.log($("#zy_radio").checked);
      } else if (item.cateid == 2) {
        // 兰州银行不请求后台接口
        this.lanzhouMsg = true;
        this.guarantorId = item.cateid;
        this.categoriesIndex = index;
        return;
        // this.lanzhouCounp = false;
        // this.lanzhouCounp = false;
      } else if (item.cateid == 3) {
        // picc中公人保
        this.nowSelectCateid = 3;
        this.address = "邮箱";
        this.Name = "中国人保";
        this.phone = "";
        this.guaranteeCompany = "";
        this.changeNum = "1";
        this.bhmoneyShow = true;
        this.lanzhouMoney = false;
        this.lanzhouCounp = true;
        this.lanzhouRadio = true;
        $("input:radio[name=invoiceStatus][value='0']").prop("checked", "true");
        $("input:radio[name=sex][value='0']").prop("checked", "true");
        this.layuiForm.render();
        this.field1.guarantor = 3;
      } else if (item.cateid == 17) {
        // 甘肃金控
        this.nowSelectCateid = 17;
        this.address = "邮箱";
        this.Name = "甘肃金控";
        this.phone = "";
        this.guaranteeCompany = "";
        this.changeNum = "1";
        this.bhmoneyShow = true;
        this.lanzhouMoney = false;
        this.lanzhouCounp = true;
        this.lanzhouRadio = true;
        $("input:radio[name=invoiceStatus][value='0']").prop("checked", "true");
        $("input:radio[name=sex][value='0']").prop("checked", "true");
        this.layuiForm.render();
        this.field1.guarantor = 17;
      } else if (item.cateid == 5) {
        // 中国农业银行
        this.lanzhouCounp = false;
        this.counpInput = false;
        this.lanzhouRadio = false;
        this.blockNameTwoShow = false;
        this.nongyeMsgShow = true;
        this.nongyeCategoriesIndex = index;
        this.switchNongyeFold();
        return;
      } else if (item.cateid == 4){
        this.nowSelectCateid = 4;
        this.address = "邮寄";
        this.Name = "黄河财险";
        this.phone = "10100018";
        this.guaranteeCompany = "hhcx";
        this.changeNum = "1";
        this.bhmoneyShow = false;
        this.lanzhouMoney = true;
        this.lanzhouCounp = false;
        this.lanzhouRadio = true;
        $("input:radio[name=invoiceStatus][value='1']").prop("checked", "true");
        $("input:radio[name=sex][value='0']").attr("checked", "checked");
        this.layuiForm.render();
        $("#one_radio").next().hide();
        this.open = true;
        this.field1.guarantor = 4;
      }
      this.guarantorId = item.cateid;
      this.categoriesIndex = index;
      this.getGuaranteeAmount();
    },

    /**
     * 担保机构选项卡, 获取担保金额
     * 某些担保机构不需要请求后台接口
     */
    async getGuaranteeAmount() {
      // 后端要求传0
      if(this.nowSelectCateid === 4) return this.guaranteeAmount = 0
      var params = {
        tradingPlatformName: this.field1.tradingPlatformName,
        marginAmount: this.field1.marginAmount,
        guarantor: this.field1.guarantor,
        couponCode: this.coupon,
      };
      let loading_fun = this.$loading({
        lock: true,
        text: "正在处理...",
        spinner: "el-icon-loading",
        background: "white",
      });
      try {
        var res = await this.$http.get("/ApplyInfo/dzbhMoney", {
          params: params,
        });
        console.log("/ApplyInfo/dzbhMoney==>", res);
        if (res.data.data) {
          this.guaranteeAmount = res.data.data.guaranteePay;
        } else {
          this.$message.error(res.data.message);
          this.guaranteeAmount = "";
        }
        loading_fun.close();
      } catch (error) {
        console.log(error);
        loading_fun.close();
        this.$message.error("网络异常, 请重试!");
      }
    },

    // ==========================    ==========================
    signOnline(e) {
      var that = this;
      var cateid = e.currentTarget.dataset.cateid;
      cateid = parseInt(cateid);
      var params2 = {
        applyInfo: {
          applyContactMobile: that.field1.applyContactMobile,
          applyContactName: that.field1.applyContactName,
          applyUser: that.field1.applyUser,
          guarantor: that.field1.guarantor,
          contactMobile: that.field1.contactMobile,
          guaranteeFee: that.field1.guaranteeFee,
          guaranteeNumber: that.field1.guaranteeNumber,
          invoiceStatus: that.field1.invoiceStatus,
          mailAddress: that.field1.mailAddress,
          marginAmount: that.field1.marginAmount,
          projectTenderer: that.field1.projectTenderer,
          tradingPlatformName: that.field1.tradingPlatformName,
          invoiceContactMobile: that.field1.contactMobile,
          legalUnitAddress: that.field1.legalUnitAddress,
          bankName: that.field1.bankName,
          bankAccount: that.field1.bankAccount,
        },
        mark: cateid,
        blockCode: that.field1.blockCode,
        blockName: that.field1.blockName,
      };
      this.$http
        .post("/ApplyInfo/createPDF", params2, {
          headers: {
            "content-type": "application/json",
            tokenId: that.$store.state.tokenId,
          },
          xhrFields: {
            withCredentials: true,
          },
        })
        .then((res) => {
          console.log(res);
          console.log(res.data.data.url);
          console.log(that.field1.applyUser);
          // online.sign(res.data.data.url, that.field1.applyUser,cateid);
          var flag = true;
          $.ajax({
            url: "http://localhost:9000/api/Sign/SignPdf",
            dataType: "json",
            data: {
              pdfFile: res.data.data.url,
              companyName: that.field1.applyUser,
            },
            success: function (res) {
              // debugger
              console.log("签章" + res);
              var str = res.substr(res.length - 6);
              console.log("最后4位是否为null" + str);
              var haveNull = str.indexOf("null") != -1;

              if (!res || str == "null" || haveNull == true || res == null) {
                flag = false;
                return;
              }
              if (cateid == 0) {
                sessionStorage.setItem("applyurl", res);
                $(".preview1").attr("href", res);
                $(".preview1").show();
                $(".preview1").next().find("span").text("重新签章");
                that.href1 = sessionStorage.getItem("applyurl");
              } else if (cateid == 1) {
                sessionStorage.setItem("allowpowerurl", res);
                $(".preview2").attr("href", res);
                $(".preview2").show();
                $(".preview2").next().find("span").text("重新签章");
                that.href2 = sessionStorage.getItem("allowpowerurl");
              }
            },

            error: function (err) {
              // ajax请求失败时返回   返回的err是一个对象
              if (err != "") {
                debugger;
                that.centerDialogVisible = true;
              }
            },
          });
          if (!flag) {
          }
          // online.initEventHandle(cateid)
          /* var applyurl2 = localStorage.getItem('applyurl');
						console.log(applyurl2){ */
          // if(res.data.status==1){
          // 	if(cateid == 0){
          // 		that.href1 =  sessionStorage.getItem('applyurl');
          // 	}else if(cateid == 1){
          // 		that.href2 =  sessionStorage.getItem('allowpowerurl');
          // 	}

          // }
        })
        .catch((error) => {
          // console.log("没安装签章");
        });
    },
    signatrue() {
      layui.use(["upload", "jquery"], function () {
        var layer = layui.layer;
        var $ = layui.jquery;
        var upload = layui.upload;
        upload.render();
        var uploadInst = upload.render({
          elem: "#signatrue2", // 绑定元素
          headers: {
            tokenId: that.$store.state.tokenId,
          },
          url: that.upUrl + "/file/upload", // 上传接口
          data: {
            module: 3,
          }, // 可选项。额外的参数，如：{id: 123, abc: 'xxx'}
          accept: "file",
          // ,auto:false,//选择图片后不自动上传
          choose: function (obj) {
            obj.preview(function (index, file, result) {
              console.log(result);
              // $('#demo1').attr('src', result); //图片链接（base64）
            });
          }, // 选择后回调，设置显示图片
          // bindAction:'#ds'//绑定元素点击再上传
          before: function (obj) {
            // 预读本地文件示例，不支持ie8
          },
          done: function (res) {
            console.log(res);
            layer.msg(resault.msg);
            // 上传完毕回调
          },
          error: function (error) {
            console.log(error);
          },
        });
      });
    },
    // 离线签章相关方法-重写以前方法, 不覆盖
    getOfflineSignatureFile(cateid) {
      this.offlineSignatureSignOnline(cateid);
    },
    upOfflineSignatureFile() {},
    // 下载对应文件
    offlineSignatureSignOnline(cateid) {
      var that = this;
      var params2 = {
        applyInfo: {
          applyContactMobile: that.field1.applyContactMobile,
          applyContactName: that.field1.applyContactName,
          applyUser: that.field1.applyUser,
          guarantor: that.field1.guarantor,
          contactMobile: that.field1.contactMobile,
          guaranteeFee: that.field1.guaranteeFee,
          guaranteeNumber: that.field1.guaranteeNumber,
          invoiceStatus: that.field1.invoiceStatus,
          mailAddress: that.field1.mailAddress,
          marginAmount: that.field1.marginAmount,
          projectTenderer: that.field1.projectTenderer,
          tradingPlatformName: that.field1.tradingPlatformName,
          invoiceContactMobile: that.field1.contactMobile,
          legalUnitAddress: that.field1.legalUnitAddress,
          bankName: that.field1.bankName,
          bankAccount: that.field1.bankAccount,
        },
        mark: cateid,
        blockCode: that.field1.blockCode,
        blockName: that.field1.blockName,
      };
      let loading_fun = this.$loading({
        lock: true,
        text: "正在处理...",
        spinner: "el-icon-loading",
        background: "white",
      });
      this.$http
        .post("/ApplyInfo/createPDF", params2, {
          headers: {
            "content-type": "application/json",
            tokenId: that.$store.state.tokenId,
          },
          xhrFields: { withCredentials: true },
        })
        .then((res) => {
          loading_fun.close();
          if (res.data.status !== 1 || res.data.data.code !== 200) {
            return this.$message.error("下载失败,请重试!");
          }
          this.$message.success("获取成功");
          if (cateid === 0) {
            this.offlineDownFileApplication = true;
          } else if (cateid === 1) {
            this.offlineDownFilePowerOfAttorney = true;
          }
          window.open(res.data.data.url);
        })
        .catch((error) => {
          loading_fun.close();
          console.error(error);
        });
    },
    // 上传前
    offlineSignatureBefUp(file, targetText) {
      let fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      let whiteList = this.uploadType;

      fileSuffix = fileSuffix.toLowerCase();
      if (whiteList.indexOf(fileSuffix) === -1) {
        this.$message.error(`上传文件只能是${whiteList.join(",")}格式`);
        return false;
      }

      this[targetText] = "上传中...";
    },
    // 上传文件成功-目前上传会进行校验。 失败与否 均会走该方法
    offlineSignatureAftersuccess(res, target, targetUrl, targetText) {
      console.log(res);
      if (!res.success) {
        this.repplay(target);
        this[targetText] = "上传失败";
        this.$message.error(res.msg);
        return;
      }
      let nowFileUrl = res.body.url_0;
      console.log(nowFileUrl);
      this[targetUrl] = nowFileUrl;
      this[targetText] = "重新上传";
      // 在提交的时候, 原本需要到sessionStorage中获取上传签章后文件的URL
      if (targetText == "applicationText") {
        sessionStorage.setItem("applyurl", nowFileUrl);
      } else if (targetText == "powerOfAttorneText") {
        sessionStorage.setItem("allowpowerurl", nowFileUrl);
      }
      this.$message.success(res.msg);
    },
    // 上传文件失败
    offlineSignatureError(err, target, targetText) {
      this.repplay(target);
      console.error(err);
      this[targetText] = "上传失败";
      this.$message.error("上传失败");
    },

    // ======================上传材料后, 提交(优化原layui表单提交)==========================
    // _flag 为0 代表点击提交按钮, 此时为获取详情. 1 为弹窗跳转支付按钮
    upFileSubmit(_flag) {
      var apply = this.getApplyData();
      if (!apply) return false;
      // _flag 为0 代表点击提交按钮, 此时为获取详情. 1 为弹窗跳转支付按钮
      apply.applyInfo.isOrNoCommit = _flag;

      var loading = this.$loading({
        lock: true,
        text: "订单提交中，请耐心等待跳转",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,.5)",
      });
      this.$http
        .post("/ApplyInfo/toApply", apply)
        .then(async ({ data: res }) => {
          debugger;
          loading.close();
          console.log("/ApplyInfo/toApply==>", res);
          console.log("this.nowSelectCateid ==>" + this.nowSelectCateid);
          if (res.status == 200) {
            // isOrNoCommit true 已经提交, 是否跳转支付界面
            // 此处是避免用户不同浏览器相同提交内容冲突验证
            if (res.data.isOrNoCommit === "1") {
              try {
                await this.$confirm(res.msg, "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                });
                this.upFileSubmit(res.data.isOrNoCommit);
              } catch (error) {}
              return;
            } else if (res.data.isOrNoCommit === "0") {
              // false项目已完成支付，请勿重复提交。
              this.$message.error(res.msg);
              return;
            }

            // 以下是根据不同担保机构, 请求成功后的不同操作
            if (this.nowSelectCateid == 2 || this.nowSelectCateid == 17) {
              // 兰州银行, 甘肃金控
              // this.$router.push("/applySuccess"); 修改为直接跳转
              this.$message.success({
                message: "提交成功, 正在跳转...",
                duration: 0,
              });
              this.$router.push({
                name: "jinkongSuccess",
                query: {
                  url: res.data,
                },
              });
            } else if (this.nowSelectCateid == 3) {
              // 张掖阳光采购 并 选择人保 跳转提示界面
              this.$router.push({
                name: "applyPiccSuccess",
                params: { registerNumber: res.data },
                query: { registerNumber: res.data },
              });
            }else if (this.nowSelectCateid == 5) {
              // 中国农业银行 跳转提示界面
              this.$router.push("/nognyeSuccess");
            } else {
              // 黄河财险
              window.location.href = res.data;
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((error) => {
          loading.close();
          console.error(error);
          this.$message.error(error);
        });
    },
    // 获取提交参数
    getApplyData() {
      var applyurl = sessionStorage.getItem("applyurl");
      var allowpowerurl = sessionStorage.getItem("allowpowerurl");
      var upload_file = this.upload_file;
      console.log("this.field1==>", this.field1);
      debugger;
      if (this.field1.guarantor == 2) {
        // 兰州银行只上传申请书
        if (!applyurl) {
          layer.msg("请上传签章文件", { icon: 5, shift: 6 });
          return false;
        }
      } else if (this.field1.guarantor == 17 || this.field1.guarantor == 5 || this.field1.guarantor == 4) {
        // 甘肃金控, 黄河财险和农业银行不上传文件
      } else if (!(applyurl && allowpowerurl)) {
        layer.msg("请上传签章文件", { icon: 5, shift: 6 });
        return false;
      }
      return {
        applyAttachments: [
          {
            type: "0",
            url: applyurl,
          },
          {
            type: "1",
            url: allowpowerurl,
          },
          {
            type: "2",
            url: upload_file,
          },
        ],
        applyInfo: {
          corpKind: this.field1.corpKind,
          applyContactMobile: this.field1.applyContactMobile,
          applyContactName: this.field1.applyContactName,
          applyUser: this.field1.applyUser,
          guaranteeFee: this.field1.guaranteeFee,
          guaranteeType: "",
          guarantor: this.field1.guarantor,
          bidOpenTime: this.field1.bidOpenTime,
          invoiceStatus: this.field1.invoiceStatus,
          mailAddress: this.field1.mailAddress,
          marginAmount: this.field1.marginAmount,
          projectTenderer: this.field1.projectTenderer,
          contactMobile: this.field1.contactMobile,
          remark: "",
          searchValue: "",
          status: "",
          tradingPlatformName: this.field1.tradingPlatformName,
          agentId: this.field1.agetnId,
          guaranteeCompany: this.field1.guaranteeCompany,
          registerNumber: this.field1.registerNumber,
          projectName: this.field1.blockNameTwo,
          invoiceContactMobile: this.field1.contactMobile,
          legalUnitAddress: this.field1.legalUnitAddress,
          bankName: this.field1.bankName,
          bankAccount: this.field1.bankAccount,
        },
        biddingResult: {
          blockCode: this.field1.blockCode,
          blockName: this.field1.blockName,
          tenderer: this.field1.blockName,
        },
        dzbhCompanyInfo: {
          companyPopulation: 0,
          turnover: this.field1.turnover,
          totalAssets: this.field1.totalAssets,
          employeesNumber: this.field1.employeesNumber,
        },
        saleNumberVO: {
          couponCode: this.coupon,
          guaranteeFee: this.newGuaranteeFee,
          guaranteePay: this.guaranteeAmount,
          guaranteeSale: this.guaranteeSale,
        },
      };
    },
    // ======================公航旅保函: 黄河财险==========================
    isCategories() {
      let nowCode = this.$store.state.platformCode;
      console.log("当前地区编码==>", nowCode);
      
      // 指定显示担保机构. 当前只有临夏有这个功能.
      if (this.designatedGuaranteeAgencys.isDesignated) {
        // 判断是否指定担保机构, 如果指定, 其余判断不执行
        this.setCategories(this.designatedGuaranteeAgencys.guaranteeAgencys);
        return;
      }
      this.setCategories([4]);
    },
    /**
     * 设置担保机构
     * cateids 需要添加的担保机构id数组[number], 如果数据已在this.categories中, 那么不添加, 避免重复展示.
     */
    setCategories(cateids) {
      if (Object.prototype.toString.call(cateids) !== "[object Array]") {
        throw "setCategories入参必须为数组";
      }
      cateids.forEach((item) => {
        const isIncludes = this.categories.filter(
          (item) => item.cateid === item
        );
        if (!isIncludes.length) {
          if (!guaranteeAgencys[item]) throw "setCategories未找到担保机构";
          // 如果没有那么添加
          this.categories.push(guaranteeAgencys[item]);
        }
      });
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.nongye-adv{
  position: fixed;
  right: 12px;
  top: 100px;
  height: 250px;
  width: 150px;
  cursor: pointer;
  img{
    height: 100%;
    width: 100%;
  }
}
::v-deep .nongyeDialog {
  height: 798px;
  .el-dialog__header {
    padding: 20px;
    border-bottom: 1px solid #dfdfdf;
    .el-dialog__title {
      font-size: 22px;
      font-weight: bold;
      color: #278770;
    }
  }
  .el-dialog__body {
    padding: 0 29px;
  }
  .el-dialog__footer {
    padding: 24px 0 33px 0;
  }
  .el-table td,
  .el-table th {
    padding: 4px 0;
  }
  .el-table {
    width: 775px;
    margin-top: 8px;
  }
}
.nongyeMsg {
  height: 629px;
  box-sizing: border-box;
  overflow-y: auto;
  padding: 16px 36px;
  border-bottom: 1px solid #dfdfdf;
  .n-title {
    font-size: 15px;
    font-weight: bold;
    color: #333333;
    position: relative;
    text-indent: 10px;
    span{
      color: #00D4C5;
    }
  }
  .n-title::before {
    content: "";
    display: block;
    width: 2px;
    height: 16px;
    background-color: #1f8b72;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .msgContent {
    margin-left: 20px;
    .nongyeFlowImg {
      width: 775px;
      height: 113px;
      margin: 8px 0 24px;
    }
    .materials {
      width: 775px;
      box-sizing: border-box;
      margin-top: 2px;
      min-height: 113px;
      background: #f8ffff;
      border-radius: 10px;
      padding: 6px 12px;
      border: 1px dashed rgba(0, 212, 197, 0.93);
      p {
        font-size: 12px;
        color: #278770;
      }
    }
    .readMore {
      display: flex;
      align-items: center;
      width: 140px;
      margin: 0 auto;
      cursor: pointer;
      .border {
        width: 30px;
        height: 1px;
        background: #c7c7c7;
      }
      span {
        font-size: 14px;
        font-weight: bold;
        color: #3083f1;
        margin: 0 5px 0 7px;
      }
      .readMoreImg {
        width: 4px;
        height: 3px;
        margin-right: 6px;
      }
    }
    .readMore2 {
      margin: 9px auto 17px;
    }
    .downApplication {
      display: flex;
      align-items: center;
      font-size: 12px;
      font-weight: bold;
      color: #333333;
      margin: 25px 0 29px 12px;
      .radio {
        width: 6px;
        height: 6px;
        background: #1f8b72;
        border-radius: 50%;
        margin-right: 6px;
      }
      a {
        width: 68px;
        height: 19px;
        background: #00d4c5;
        border-radius: 5px;
        text-align: center;
        line-height: 19px;
        font-size: 12px;
        font-weight: bold;
        color: #ffffff;
        margin-left: 6px;
      }
    }
  }
}
.nongyeMsgCancel {
  width: 167px;
  height: 47px;
  background: #f5f5f5;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  color: #888888;
  border-color: #f5f5f5;
}
.nongyeMsgSure {
  width: 167px;
  height: 47px;
  background: #00d4c5;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  color: #ffffff;
  border-color: #00d4c5;
  margin-left: 47px;
}

.requiredRed {
  color: red;
  position: absolute;
  left: 17px;
}
.billingInformation {
  margin-top: -35px;
  .layui-timeline-title {
    font-size: 14px;
    position: static;
    display: inline-block;
  }
  .billingInput {
    display: flex;
    line-height: 28px;
    input {
      width: 229px;
      height: 28px !important;
    }
  }
}
.layui-form-selected dl {
  height: 230px !important;
}
body .layui-form-selected dl {
  height: 230px !important;
}
// 兰州弹框提示
.feedbackdiv {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  outline: 0;
  -webkit-overflow-scrolling: touch;
  background-color: rgb(0, 0, 0);
  filter: alpha(opacity=60);
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9998;
  .feedback_content {
    border: 1px solid #ccc;
    position: absolute;
    width: 505px;
    height: 426px;
    border: 0px;
    top: 50%;
    left: 50%;
    margin-top: -139px;
    margin-left: -220px;
    background-color: #fff;

    z-index: 9999;
    .feedback_top {
      height: 60px;
      //   border-bottom: 1px solid #ccc;
      font-weight: 400;
      font-size: 14px;
      color: #37b1d4;
      text-indent: 36px;
      line-height: 60px;
      font-weight: 500;
    }
    .feedback_center {
      #feedback_text {
        width: 423px;
        padding: 0px 20px 0px 36px;
        font-size: 13px;
        color: #666666;

        p {
          span {
            display: inline-block;
            line-height: 23px;
            line-height: 23px;
          }
        }
      }
      #feedback_textTwo {
        //  width: 423px;
        //  height: 195px;
        padding: 0px 20px 31px 36px;
        font-size: 13px;
        color: #666666;

        p {
          span {
            display: inline-block;
            line-height: 23px;
            line-height: 23px;
          }
          &:nth-child(1) {
            margin-bottom: 14px;
          }
          &:nth-child(3) {
            margin-bottom: 14px;
          }
          &:nth-child(4) {
            margin-bottom: 14px;
          }
          &:nth-child(6) {
            margin-bottom: 14px;
          }
          &:nth-child(7) {
            margin-bottom: 14px;
          }
          &:nth-child(8) {
            margin-bottom: 14px;
          }
          &:nth-child(9) {
            margin-bottom: 14px;
          }
        }
      }
    }
    .feedback_button {
      display: flex;
      margin-top: 89px;
      div {
        width: 252px;
        height: 40px;
        font-size: 16px;
        line-height: 40px;
        text-align: center;
        background-color: rgba(255, 255, 255, 1);
        &:nth-child(1) {
          border-right: 1px solid rgba(170, 170, 170, 1);
          border-top: 1px solid rgba(170, 170, 170, 1);
          cursor: pointer;
          //   margin-left: 146px;
        }
        &:nth-child(2) {
          height: 40px;
          //   background-color: #19AECF;
          border-top: 1px solid rgba(170, 170, 170, 1);
          color: #3bb4d5;
          cursor: pointer;
          //   margin-left: 20px;
        }
      }
    }
  }
}

/deep/ .el-dialog {
  margin-top: 0px !important;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.my-background {
  height: 556px;
  // background: rgb(184, 184, 185);
}
.search {
  position: absolute;
  top: 63px;
  left: 0px;
  width: 298px;
  border-left: 1px solid #e6e6e6;
  border-right: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
  background-color: #fff;
  z-index: 2000;
}
.searchcontent {
  cursor: pointer;
  width: 299px;
  height: 37px;
  line-height: 37px;
  background-color: #fff;
  text-indent: 10px;
  // z-index: 2000;
}
.searchcontent:hover {
  background-color: #fafafa;
}
.layui-btn {
  line-height: 40px;
}
.bottom-btn {
  margin-bottom: 0;
  margin-top: 70px;
  text-align: center;
}

.bottom-btn2 {
  margin-top: 72px;
  text-align: center;
}

.layui-form label span {
  font-size: 12px;
  color: #ff5555;
}

.layui-input-block {
  margin-left: 0;
}

.layui-carousel {
  height: 100% !important;
  // max-height: 665px !important;
  // overflow: hidden !important;
}

//时间树
.timeline-title-div {
  width: 155px;
  text-align: right;
  position: relative;
  left: -196px;
  z-index: 100;

  .layui-timeline-title {
    width: 100%;
    font-size: 14px;
    position: static;
    display: inline-block;
    white-space: nowrap;
    & > span {
      color: #ff5555;
    }
  }
}

.layui-timeline-content > p {
  margin-top: -32px;
  font-size: 14px;
  color: #3c4f57;
}

.layui-timeline {
  padding-left: 23px;
}

.layui-form-radio {
  margin: 0 !important;
}

#stepForm .layui-timeline .layui-input-block p {
  font-size: 11px;
  color: #3c4f57;
  opacity: 0.5;
  line-height: 18px;
}

#stepForm .layui-timeline .layui-timeline-content > p {
  font-size: 14px;
  color: #3c4f57;
}

.count {
  font-size: 24px;
  color: #ff5900;
}

.layui-card {
  box-shadow: none;
}

.main3 {
  display: flex;
  padding: 40px 40px 0 40px;
  flex-wrap: nowrap;
  justify-content: space-between;

  hr {
    height: 352px;
    width: 1px;
    background: #e1e8ec;
  }

  &-left {
    width: 60%;

    .h2-title {
      font-size: 18px;
      color: #3c4f57;
      letter-spacing: 0;
      font-weight: bold;
    }
  }

  &-right {
    width: 34%;

    & > h2 {
      font-size: 18px;
      color: #3c4f57;
      margin-bottom: 40px;
      font-weight: bold;
    }

    & > ul li {
      h3 {
        margin-bottom: 14px;
        font-size: 14px;
        font-weight: bold;
        color: #3c4f57;

        & > img {
          margin-right: 8px;
        }
      }

      p {
        opacity: 0.7;
        font-size: 13px;
        color: #3c4f57;
        line-height: 20px;
        margin-bottom: 32px;
      }
    }
  }
}

.small-title {
  margin-bottom: 40px;
  font-size: 14px;
  color: #95b3be;
  letter-spacing: 0;

  // line-height: px;
  span {
    color: #19aecf;
  }
}

.ul1 {
  width: 100%;
}

.ul1 li {
  position: relative;
  height: 50px;
  margin-bottom: 24px;

  h2 {
    position: relative;
    font-size: 14px;
    color: #3c4f57;
    width: 468px;
    height: 100%;
    line-height: 50px;
    border: 1px solid #e1e8ec;
    background: #fbfcfd;

    img {
      margin: -5px 0 0 24px;
    }

    .preview {
      font-size: 14px;
      color: #19aecf;
      position: absolute;
      right: 132px;
      top: 30px;
      line-height: initial;
    }

    .signatrue {
      position: absolute;
      top: 50%;
      right: 24px;
      margin-top: -14px;
      background: #19aecf;
      border: 1px solid #e1e8ec;
      border-radius: 2px;
      width: 92px;
      height: 28px;
      text-align: center;
      line-height: 28px;

      span {
        color: #ffffff;
        font-size: 14px;
      }
    }
  }

  .look-instance {
    position: absolute;
    right: 0;
    top: 50%;
    font-size: 14px;
    margin-top: -12px;
    text-decoration: underline;
    color: #19aecf;
  }
}

.bottom-btn3 {
  text-align: center;
}

.guarantee-div {
  width: 540px;
  overflow: hidden;

  & > div {
    position: relative;
    width: 159.5px;
    height: 160px;
    float: left;
    margin-right: 20px;
    overflow: hidden;
    margin-bottom: 10px;
    & > img {
      position: absolute;
      left: 1px;
      top: 1px;
      width: 157px;
      height: 157px;
    }

    .unchanged {
      background: url(~@/assets/unchanged.png) no-repeat;
      background-size: 159px 159px;
      width: 100%;
      height: 100%;
    }

    .changed {
      background: url(~@/assets/changed.png) no-repeat;
      background-size: 159px 159px;
      width: 100%;
      height: 100%;
    }

    .rate {
      font-size: 12px;
      position: absolute;
      top: 50px;
      left: 37px;
    }

    .look-details {
      font-size: 12px;
      position: absolute;
      top: 118px;
      left: 37px;
      color: skyblue;
    }
  }
}

#layer122 {
  background: transparent;
  position: relative;
  height: 502px;
  padding-top: 57px;
  .layer-div {
    width: 500px;
    height: 419px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-56%, -167px);
    background: #ffffff;

    & > h3 {
      margin-top: 90px;
      text-align: center;
      font-size: 18px;
      color: #3c4f57;
    }
    & > p {
      font-size: 13px;
      color: #3c4f57;
      padding: 0px 60px;
      margin-bottom: 13px;
      margin-top: 8px;
      line-height: 30px;
    }
    .btn1 {
      margin-top: 22px;
      text-align: center;
      margin-left: auto;
      margin-right: auto;
      display: block;
      width: 433px !important;
    }
    .AGFooter {
      height: 40px;
      line-height: 42px;
      // background-color: #FAFBFC;
      border-top: 1px solid #e1e8ec;
      position: absolute;
      left: 0px;
      bottom: 39px;
      width: 100%;
      z-index: 1;
      text-align: center;
      a {
        text-decoration: underline;
        color: #19aecf;
      }
    }
    .square {
      width: 152px;
      height: 133px;
      background: url(~@/assets/img1.png) no-repeat;
      background-size: 152px 133px;
      position: absolute;
      left: 50%;
      margin-left: -76px;
      top: -67px;
    }
  }
}

.el-upload {
  width: 94px !important;
  height: 30px !important;
}

// 离线签章
.ul1 .offline-signature {
  height: 80px;
  h2 {
    line-height: 80px;
  }
  // 重置按钮定位
  &-btn {
    position: absolute;
    top: 50%;
    right: 24px;
    transform: translateY(-50%);
    line-height: 1;
    & > div {
      display: inline-block;
      margin-left: 10px;
    }
    .signatrue {
      position: relative;
      top: 0px;
      right: 0px;
      margin-top: 0px;
      padding: 0 5px;
      width: auto;
      height: 30px;
      line-height: 30px;
      &-disabled {
        background: #e1e8ec;
        color: #c0c4cc;
        cursor: not-allowed;
      }
    }
  }

  // 切换
  &-switch {
    position: absolute;
    line-height: 1;
    top: 76%;
    right: 24px;
    a {
      display: inline-block;
      position: unset !important;
    }
    p {
      margin-left: 10px;
      display: inline-block;
      color: #666;
      font-size: 12px;
      cursor: pointer;
      transition: 0.3s;
      &:hover {
        color: #19aecf;
      }
    }
  }
}
</style>
